(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-product-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  // 18/10/2026 : pas de « Enregistrer / ouvrir l'image » sur la fiche (clic droit,
  // appui long, glisser) : le visuel de l'aperçu au mur est le design seul.
  // Ne bloque que les images : le clic droit marche toujours sur les liens et le texte.
  var mlNoSave = function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.ml-product') && (t.tagName === 'IMG' || t.closest('.ml-live, .ml-gallery-zoom, [data-ml-gallery]'))) e.preventDefault();
  };
  document.addEventListener('contextmenu', mlNoSave);
  document.addEventListener('dragstart', mlNoSave);
})();
(function () {
  // Textes traduits (bloc data-ml-i18n de la section) ; repli = français.
  var mlI18n = null;
  var mlT = function (k, d) {
    if (!mlI18n) { try { mlI18n = JSON.parse(document.querySelector('[data-ml-i18n]').textContent); } catch (e) { mlI18n = {}; } }
    return mlI18n[k] || d;
  };
  function initProductPage(sectionId) {
    var section = document.querySelector('[data-section-id="' + sectionId + '"]');
    if (!section) return;

    // Short description toggle (Voir plus / Voir moins)
    var descToggle = section.querySelector('[data-ml-desc-toggle]');
    if (descToggle) {
      descToggle.addEventListener('click', function() {
        var wrap = descToggle.closest('[data-ml-desc]');
        if (!wrap) return;
        var expanded = wrap.classList.toggle('is-expanded');
        descToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        var more = descToggle.querySelector('[data-label-more]');
        var less = descToggle.querySelector('[data-label-less]');
        if (more && less) {
          more.hidden = expanded;
          less.hidden = !expanded;
        }
      });
    }

    // Thumbnail switching
    var thumbs = section.querySelectorAll('.ml-product__thumb');
    var medias = section.querySelectorAll('.ml-product__media');
    var counter = section.querySelector('.ml-gallery-current');

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() {
        var mediaId = thumb.dataset.mediaId;
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        medias.forEach(function(m) { m.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        // 22/10/2026 (user : l'aperçu en direct disparaît après des changements de variante et des allers-retours) :
        // quand l'aperçu est dans la vignette / le bandeau du téléphone, il n'est plus DANS la section — la recherche
        // ne le trouvait pas, il perdait « is-active » et revenait masqué dans la galerie. Référence directe.
        var target = section.querySelector('.ml-product__media[data-media-id="' + mediaId + '"]') || (mediaId === 'live' ? section.__mlLive : null);
        if (target) target.classList.add('is-active');
        if (counter) counter.textContent = i + 1;
      });
    });

    // Variant data
    var variants = [];
    var variantScript = section.querySelector('script[data-ml-variants]');
    if (variantScript) {
      try { variants = JSON.parse(variantScript.textContent); } catch(e) { variants = []; }
    }

    var variantIdInput = section.querySelector('#ml-variant-id-' + sectionId);
    var priceBlock = section.querySelector('[data-ml-price-block]');
    var priceCurrent = section.querySelector('[data-ml-current]');
    var priceCompare = section.querySelector('[data-ml-compare]');
    var priceSave = section.querySelector('[data-ml-save]');
    var priceSaveAmount = section.querySelector('[data-ml-save-amount]');
    var atcBtn = section.querySelector('[data-ml-atc]');
    var atcText = section.querySelector('[data-ml-atc-text]');
    var atcPrice = section.querySelector('[data-ml-atc-price]');
    var atcLabelEl = section.querySelector('[data-ml-atc-default-label]');
    var atcDefaultLabel = atcLabelEl ? atcLabelEl.textContent.trim() : mlT('ajouter_panier', 'Ajouter au panier');

    /* --- Barre d'achat collante (mobile) ---
       Se cale sur l'état du vrai bouton : prix, libellé, disponibilité.
       Visible seulement quand le vrai bouton n'est plus à l'écran. */
    (function initStickyAtc() {
      var stickyBar = section.querySelector('[data-ml-sticky]');
      var stickyPrice = section.querySelector('[data-ml-sticky-price]');
      var stickyBtn = section.querySelector('[data-ml-sticky-btn]');
      if (!stickyBar || !stickyBtn || !atcBtn) return;

      function syncSticky() {
        if (stickyPrice && atcPrice) {
          // atcPrice contient " — 69,00 €" ; on ne garde que le montant
          stickyPrice.textContent = atcPrice.textContent.replace(/^[\s—–-]+/, '').trim();
        }
        var stickySum = section.querySelector('[data-ml-sticky-sum]');
        if (stickySum) {
          var parts = [];
          section.querySelectorAll('.ml-buybox .ml-variant-btn__input:checked').forEach(function(r) { parts.push(mlNiceValue(r.value)); });
          stickySum.textContent = parts.join(', ');
        }
        var sold = atcBtn.disabled;
        stickyBtn.disabled = sold;
        stickyBtn.textContent = sold ? mlT('epuise', 'Épuisé') : atcDefaultLabel;
        if (stickyPrice) stickyPrice.hidden = sold;
      }

      stickyBtn.addEventListener('click', function() { atcBtn.click(); });
      section.addEventListener('change', function() { setTimeout(syncSticky, 0); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            // seulement une fois le vrai bouton DÉPASSÉ (au-dessus de l'écran), pas avant de l'atteindre
            stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
          });
        }, { threshold: 0 }).observe(atcBtn);
      }

      syncSticky();
    })();

    // Prix sur téléphone (02/11/2026, user : « le prix apparaît tout en haut, ça fait bizarre ») : en une colonne,
    // le prix du haut passe SOUS l'image (en tête des options) ; il revient sous le titre dès qu'il y a 2 colonnes.
    // Le JS met le prix à jour par sélecteur : sa place dans la page est libre.
    (function priceUnderImage() {
      var price = section.querySelector('.ml-product__price-wrap--head');
      var layoutEl = section.querySelector('.ml-product__layout');
      var details = section.querySelector('.ml-product__details');
      if (!price || !layoutEl || !details) return;
      var home = price.parentNode, homeNext = price.nextSibling;
      function place() {
        var one = getComputedStyle(layoutEl).gridTemplateColumns.trim().split(/\s+/).length === 1;
        if (one && price.parentNode !== details) {
          details.insertBefore(price, details.firstChild);
          price.classList.add('is-under-image');
        } else if (!one && price.parentNode === details) {
          home.insertBefore(price, homeNext && homeNext.parentNode === home ? homeNext : null);
          price.classList.remove('is-under-image');
        }
      }
      place();
      var t;
      window.addEventListener('resize', function() { clearTimeout(t); t = setTimeout(place, 120); });
    })();

    function getSelectedValues() {
      var values = [null, null, null];
      section.querySelectorAll('.ml-variant-group').forEach(function(group) {
        var idx = parseInt(group.dataset.optionIndex, 10);
        if (!idx) return;
        var checked = group.querySelector('.ml-variant-btn__input:checked');
        if (checked) values[idx - 1] = checked.value;
      });
      return values;
    }

    function findVariant(values) {
      return variants.find(function(v) {
        return v.option1 === values[0] && v.option2 === values[1] && v.option3 === values[2];
      });
    }

    function syncToVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      // Délai de livraison : plus court pour une affiche sans cadre (13/10/2026)
      var dlEl = section.querySelector('[data-ml-dl-sans]');
      if (dlEl) {
        var sans = /sans cadre|zonder lijst|senza cornice|sin marco/i.test([variant.option1, variant.option2, variant.option3].join(' '));
        dlEl.textContent = dlEl.getAttribute(sans ? 'data-ml-dl-sans' : 'data-ml-dl-cadre');
      }

      if (priceCurrent) priceCurrent.textContent = variant.price;

      var hasSale = variant.compare_at_price && variant.compare_at_price_cents > variant.price_cents;
      if (priceBlock) priceBlock.classList.toggle('ml-price--sale', hasSale);
      if (priceCompare) {
        if (hasSale) {
          priceCompare.textContent = variant.compare_at_price;
          priceCompare.hidden = false;
        } else {
          priceCompare.hidden = true;
        }
      }
      if (priceSave) {
        if (hasSale && variant.saving) {
          if (priceSaveAmount) priceSaveAmount.textContent = variant.saving;
          priceSave.hidden = false;
        } else {
          priceSave.hidden = true;
        }
      }

      if (atcBtn) {
        if (variant.available) {
          atcBtn.disabled = false;
          atcBtn.removeAttribute('aria-disabled');
          if (atcText) atcText.textContent = atcDefaultLabel;
          if (atcPrice) {
            atcPrice.textContent = ' — ' + variant.price;
            atcPrice.hidden = false;
          }
        } else {
          atcBtn.disabled = true;
          atcBtn.setAttribute('aria-disabled', 'true');
          if (atcText) atcText.textContent = mlT('epuise', 'Épuisé');
          if (atcPrice) atcPrice.hidden = true;
        }
      }

      // Affiches : si l'aperçu au mur est affiché, on y reste — il se met à
      // jour tout seul avec le cadre et le format choisis. Sauter vers la
      // photo de la variante ferait perdre ce qu'on est en train de régler.
      // 20/10/2026 : quand l'aperçu est dans le bandeau épinglé (téléphone), il n'est plus DANS la section :
      // la recherche ne le trouvait pas, la photo de la variante prenait sa place et, au retour, l'aperçu
      // restait masqué (écran blanc). On garde donc une référence directe (section.__mlLive).
      var liveEl = section.querySelector('[data-ml-live]') || section.__mlLive || null;
      var liveShown = liveEl && liveEl.classList.contains('is-active') ? liveEl : null;
      var livePoster = liveEl && liveEl.getAttribute('data-support') === 'affiche' ? liveEl : null;
      if (livePoster) {
        // Affiches (06/10/2026) : aucune photo par variante — on revient sur
        // l'aperçu en direct, qui montre le format et le cadre choisis.
        if (!liveShown) {
          var liveThumb = section.querySelector('.ml-product__thumb[data-media-id="live"]');
          if (liveThumb) liveThumb.click();
          else {
            medias.forEach(function(m) { m.classList.remove('is-active'); });
            livePoster.classList.add('is-active');
          }
        }
      } else if (variant.featured_media_id && !liveShown) {
        var mediaId = String(variant.featured_media_id);
        var targetMedia = section.querySelector('.ml-product__media[data-media-id="' + mediaId + '"]');
        var targetThumb = section.querySelector('.ml-product__thumb[data-media-id="' + mediaId + '"]');
        if (targetMedia) {
          medias.forEach(function(m) { m.classList.remove('is-active'); });
          targetMedia.classList.add('is-active');
          if (counter) {
            var mediaIndex = targetThumb ? Array.prototype.indexOf.call(thumbs, targetThumb) : Array.prototype.indexOf.call(medias, targetMedia);
            if (mediaIndex >= 0) counter.textContent = mediaIndex + 1;
          }
        }
        if (targetThumb) {
          thumbs.forEach(function(t) { t.classList.remove('is-active'); });
          targetThumb.classList.add('is-active');
        }
        // Volontairement AUCUN scrollIntoView ici. L'image de la galerie change,
        // mais la page ne bouge pas : sur mobile, choisir une taille faisait
        // remonter la vue et on perdait le sélecteur qu'on était en train
        // d'utiliser. Ne pas le réintroduire.
      }
    }

    // Recompute finition deltas based on currently selected size (or other options)
    function formatDeltaEur(cents) {
      var euros = cents / 100;
      var s = euros.toFixed(2).replace('.', ',');
      // 20/10 : décimales gardées (« 29,00 € » fait moins « produit de luxe », user)
      return '+' + s + ' €';
    }
    function recomputeFinitionDeltas() {
      var finitionGroup = section.querySelector('.ml-variant-group--finition');
      if (!finitionGroup) return;
      var finitionIdx = parseInt(finitionGroup.dataset.optionIndex, 10);
      if (!finitionIdx) return;
      var selected = getSelectedValues();
      var pricesByValue = {};
      finitionGroup.querySelectorAll('.ml-variant-btn__input').forEach(function(input) {
        var finitionVal = input.value;
        var probe = selected.slice();
        probe[finitionIdx - 1] = finitionVal;
        var match = findVariant(probe);
        if (match) pricesByValue[finitionVal] = match.price_cents;
      });
      var min = Infinity;
      Object.keys(pricesByValue).forEach(function(k) { if (pricesByValue[k] < min) min = pricesByValue[k]; });
      finitionGroup.querySelectorAll('.ml-variant-btn--finition').forEach(function(btn) {
        var input = btn.querySelector('.ml-variant-btn__input');
        var priceEl = btn.querySelector('.ml-variant-btn__price');
        if (!input || !priceEl) return;
        var price = pricesByValue[input.value];
        // Cadre qui n'existe pas dans ce format : carte grisée et INACTIVE
        // (13/10/2026, user : sur le 100 × 70 sans cadre, cliquer « Cadre noir »
        // ne doit plus basculer sur un format plus petit — mieux vaut ne rien faire).
        btn.classList.toggle('is-unavailable', price === undefined);
        input.disabled = price === undefined;
        if (price === undefined) {
          priceEl.textContent = mlT('indisponible', 'Indisponible');
          priceEl.classList.add('ml-variant-btn__price--muted');
          return;
        }
        var delta = price - min;
        if (delta > 0) {
          priceEl.textContent = formatDeltaEur(delta);
          priceEl.classList.remove('ml-variant-btn__price--muted');
        } else {
          priceEl.textContent = mlT('inclus', 'Inclus');
          priceEl.classList.add('ml-variant-btn__price--muted');
        }
      });
    }

    // « 70 x 50cm » → « 70 × 50 cm » (même écriture que le Liquid).
    function mlNiceValue(v) {
      return String(v).replace(/\s*[x×]\s*/g, ' × ').replace(/\s*cm/gi, ' cm').replace(/\s+/g, ' ').trim();
    }

    // Variant picker — update selection state and sync price/CTA
    var variantGroups = section.querySelectorAll('.ml-variant-group');
    variantGroups.forEach(function(group) {
      var radios = group.querySelectorAll('.ml-variant-btn__input');
      var selectedSpan = group.querySelector('.ml-variant-group__selected');
      radios.forEach(function(radio) {
        radio.addEventListener('change', function() {
          group.querySelectorAll('.ml-variant-btn').forEach(function(b) { b.classList.remove('is-selected'); });
          radio.closest('.ml-variant-btn').classList.add('is-selected');
          if (selectedSpan) selectedSpan.textContent = mlNiceValue(radio.value);

          var selected = getSelectedValues();
          var match = findVariant(selected);
          if (!match) {
            // Combinaison qui n'existe pas (ex. affiche 100 × 70 : sans cadre
            // seulement). On garde le choix qu'on vient de faire et on bascule
            // les AUTRES options sur la première variante qui l'accepte —
            // sinon le bouton panier garderait l'ancienne variante.
            var idx = parseInt(group.dataset.optionIndex, 10) - 1;
            // En partant de la fin : un cadre choisi sur le 100 × 70 ramène au
            // plus grand format encadré, le plus proche de ce qu'on regardait.
            var candidats = variants.filter(function(v) { return v['option' + (idx + 1)] === radio.value; }).reverse();
            var fallback = candidats.find(function(v) { return v.available; }) || candidats[0];
            if (fallback) {
              variantGroups.forEach(function(g, gi) {
                var want = fallback['option' + (parseInt(g.dataset.optionIndex, 10))];
                var target = Array.prototype.find.call(g.querySelectorAll('.ml-variant-btn__input'), function(i) { return i.value === want; });
                if (target && !target.checked) { target.checked = true; target.dispatchEvent(new Event('change', { bubbles: true })); }
              });
              return;
            }
          }
          syncToVariant(match);
          recomputeFinitionDeltas();
        });
      });
    });

    // Initial pass — make sure deltas reflect the default selection
    recomputeFinitionDeltas();

    /* --- Aperçu au mur (affiches) : moteur de mise en situation ---
       D'après MOCKUP-SPEC.md (prototype du user). Tout est exprimé en
       centimètres dans le repère du mur — u vers la droite, v hauteur depuis
       le sol, w décollement vers la caméra — puis projeté dans la photo du
       décor par une vraie perspective, reconstruite à partir de 4 points
       calibrés (bloc « Décor », réglage Calibrage). Chaque face de l'œuvre
       est un rectangle plaqué par homographie (matrix3d) : les proportions
       restent justes, même en vue de trois-quarts. */
    (function initLivePreview() {
      var live = section.querySelector('[data-ml-live]');
      if (live) section.__mlLive = live;
      if (!live) return;
      var box = live.closest('.ml-product__gallery-inner') || live;
      var world = live.querySelector('[data-ml-world]');
      // 20/10/2026 (user, iPhone : aperçu saccadé, parfois blanc après un aller-retour) :
      // écran tactile = pas de flou CSS sur l'affiche (0,3 px de photo, invisible sur téléphone,
      // mais Safari le recalcule à chaque image) ; et la scène est redessinée quand elle revient à l'écran.
      var coarse = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);
      function repaint() {
        world.style.visibility = 'hidden';
        void world.offsetWidth;
        requestAnimationFrame(function() { world.style.visibility = ''; });
      }
      var shadowEl = live.querySelector('[data-ml-shadow]');
      var side = live.querySelector('[data-ml-side]');
      var poster = live.querySelector('[data-ml-poster]');
      var gapEl = live.querySelector('[data-ml-gap]');
      var lights = { tint: live.querySelectorAll('.ml-live__light--tint'), sun: live.querySelectorAll('.ml-live__light--sun'), veil: live.querySelectorAll('.ml-live__light--veil') };
      var posterLit = poster.querySelector('.ml-live__lit'), sideLit = side.querySelector('.ml-live__lit');
      var caption = live.querySelector('[data-ml-live-caption]');
      var artImg = live.querySelector('.ml-live__art');
      var support = live.dataset.support === 'toile' ? 'toile' : 'affiche';
      var artRatio = parseFloat(live.dataset.artRatio) || 1;
      var view = live.dataset.view || 'flat';
      var decors = [];
      try { decors = JSON.parse(live.querySelector('[data-ml-decors]').textContent) || []; } catch (e) { decors = []; }

      // AFFICHES (06/10/2026, cahier des charges du user) : calques de réalisme
      // créés ici, pas dans le Liquid, pour que la fiche ET le générateur
      // d'images fixes (_generer-mockups.js, qui a son propre HTML) les aient.
      // Dans le papier : relevé des noirs, grain, ombre du cadre, vitre, reflet.
      // Autour : 4 baguettes à onglets texturées, joints d'onglet, arête intérieure.
      var isPoster = support === 'affiche', miterPath = null, LIT_IN = 1;
      if (isPoster) {
        var mk = function(cls, tag) { var e = document.createElement(tag || 'div'); e.className = cls; e.setAttribute('aria-hidden', 'true'); return e; };
        var artwrap = live.querySelector('.ml-live__artwrap');
        artwrap.insertBefore(mk('ml-live__lift'), artwrap.querySelector('.ml-live__texture'));
        artwrap.appendChild(mk('ml-live__refl'));
        var rails = mk('ml-live__rails');
        ['t', 'r', 'b', 'l'].forEach(function(k) { rails.appendChild(mk('ml-live__rail ml-live__rail--' + k, 'i')); });
        var svgNS = 'http://www.w3.org/2000/svg', miter = document.createElementNS(svgNS, 'svg');
        miter.setAttribute('class', 'ml-live__miter');
        miter.setAttribute('aria-hidden', 'true');
        miterPath = document.createElementNS(svgNS, 'path');
        miterPath.setAttribute('fill', 'none');
        miterPath.setAttribute('stroke-linecap', 'round');
        miter.appendChild(miterPath);
        var lip = mk('ml-live__lip'), gap0 = poster.querySelector('.ml-live__gap');
        poster.insertBefore(rails, gap0);
        poster.insertBefore(miter, gap0);
        poster.insertBefore(lip, gap0);
        // reflet de la pièce dans la vitre, tiré de la photo du décor (16/10/2026)
        posterLit.appendChild(mk('ml-live__light ml-live__light--glass'));
      }

      // Matières des cadres (dégradés repris du prototype).
      var FRAMES = {
        black: 'linear-gradient(135deg,#2c2c2c,#121212)',
        white: 'linear-gradient(135deg,#ffffff,#e6e4e0)',
        oak: 'repeating-linear-gradient(90deg,rgba(80,50,20,.12) 0 1px,transparent 1px 5px),repeating-linear-gradient(0deg,rgba(80,50,20,.10) 0 1px,transparent 1px 6px),linear-gradient(135deg,#CFA06C,#B07E4C)',
        'oak-light': 'repeating-linear-gradient(90deg,rgba(140,100,55,.10) 0 1px,transparent 1px 5px),repeating-linear-gradient(0deg,rgba(140,100,55,.08) 0 1px,transparent 1px 6px),linear-gradient(135deg,#EBD3AE,#D6B88B)'
      };
      // Toiles (02/11/2026, user : « le chêne clair est un poil plus foncé ») — les affiches gardent leur bois naturel validé
      if (support === 'toile') FRAMES['oak-light'] = 'repeating-linear-gradient(90deg,rgba(130,90,48,.11) 0 1px,transparent 1px 5px),repeating-linear-gradient(0deg,rgba(130,90,48,.09) 0 1px,transparent 1px 6px),linear-gradient(135deg,#DFC49B,#C9A878)';

      function frameKind(v) {
        v = (v || '').toLowerCase().replace(/zwart/g, 'noir').replace(/eiken/g, 'chêne').replace(/hout/g, 'bois naturel').replace(/nera/g, 'noir').replace(/rovere/g, 'chêne').replace(/legno/g, 'bois naturel').replace(/negro/g, 'noir').replace(/roble/g, 'chêne').replace(/madera/g, 'bois naturel');
        if (v.indexOf('blanc') > -1) return 'white';
        if (v.indexOf('bois naturel') > -1) return 'oak-light';   // 20/10/2026 : « Chêne clair » renommé « Bois naturel » sur les affiches (user)
        if (v.indexOf('naturel') > -1) return 'oak';
        if (/ch[eê]ne|bois clair/.test(v)) return 'oak-light';
        if (v.indexOf('noir') > -1) return 'black';
        return 'none';
      }
      function readDims(v) {
        var m = (v || '').replace(/,/g, '.').match(/(\d+(?:\.\d+)?)\s*[x×*]\s*(\d+(?:\.\d+)?)/i);
        return m ? [parseFloat(m[1]), parseFloat(m[2])] : null;
      }
      function fmt(n) { return String(Math.round(n * 10) / 10).replace('.', ','); }
      function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

      // --- Algèbre : système linéaire, homographies, enveloppe convexe ---
      function solve(A, B) {
        var n = B.length, M = A.map(function(r, i) { return r.concat(B[i]); });
        for (var c = 0; c < n; c++) {
          var p = c;
          for (var r = c + 1; r < n; r++) if (Math.abs(M[r][c]) > Math.abs(M[p][c])) p = r;
          var tmp = M[c]; M[c] = M[p]; M[p] = tmp;
          for (var r2 = 0; r2 < n; r2++) {
            if (r2 === c) continue;
            var k = M[r2][c] / M[c][c];
            for (var j = c; j <= n; j++) M[r2][j] -= k * M[c][j];
          }
        }
        return M.map(function(row, i) { return row[n] / row[i]; });
      }
      // mur (cm) → photo (px), à partir de 4 correspondances
      function homography(src, dst) {
        var A = [], B = [];
        for (var i = 0; i < 4; i++) {
          var u = src[i][0], v = src[i][1], x = dst[i][0], y = dst[i][1];
          A.push([u, v, 1, 0, 0, 0, -u * x, -v * x]); B.push(x);
          A.push([0, 0, 0, u, v, 1, -u * y, -v * y]); B.push(y);
        }
        var h = solve(A, B);
        return [[h[0], h[1], h[2]], [h[3], h[4], h[5]], [h[6], h[7], 1]];
      }
      // rectangle W×H (px) → quadrilatère q [HG, HD, BD, BG]
      // même transformation, sous forme de matrice 3x3 (élément → photo)…
      function quadH(W, H, q) {
        var x0 = q[0][0], y0 = q[0][1], x1 = q[1][0], y1 = q[1][1], x2 = q[2][0], y2 = q[2][1], x3 = q[3][0], y3 = q[3][1];
        var dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3, dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;
        var den = dx1 * dy2 - dx2 * dy1;
        var g = (dx3 * dy2 - dx2 * dy3) / den, h = (dx1 * dy3 - dx3 * dy1) / den;
        return [[(x1 - x0 + g * x1) / W, (x3 - x0 + h * x3) / H, x0], [(y1 - y0 + g * y1) / W, (y3 - y0 + h * y3) / H, y0], [g / W, h / H, 1]];
      }
      // …son inverse (photo → élément)…
      function inv3(m) {
        var a = m[0][0], b = m[0][1], c = m[0][2], d = m[1][0], e = m[1][1], f = m[1][2], g = m[2][0], h = m[2][1], i = m[2][2];
        var A = e * i - f * h, B = -(d * i - f * g), C = d * h - e * g, det = a * A + b * B + c * C;
        return [[A / det, -(b * i - c * h) / det, (b * f - c * e) / det], [B / det, (a * i - c * g) / det, -(a * f - c * d) / det], [C / det, -(a * h - b * g) / det, (a * e - b * d) / det]];
      }
      // …et en CSS
      function css3(m) {
        return 'matrix3d(' + [m[0][0], m[1][0], 0, m[2][0], m[0][1], m[1][1], 0, m[2][1], 0, 0, 1, 0, m[0][2], m[1][2], 0, m[2][2]].join(',') + ')';
      }
      // Calques de lumière d'une face : taille de la photo, transformation
      // inverse de la face → une fois la face transformée, ils retombent pile
      // sur la photo du décor.
      function placeLit(lit, m, WW, WH) {
        if (!lit) return;
        // Affiches : le calque de lumière s'arrête 1 px avant le bord (CSS
        // « Réalisme affiche ») — sur le tout dernier pixel, le navigateur
        // mélangeait mal le « produit » et dessinait un liseré clair autour de
        // l'affiche. On décale d'autant son contenu pour qu'il reste calé.
        // Toiles (02/11/2026) : 2 px. Sur le pixel du bord, à moitié couvert, le navigateur peint la lumière (photo du mur)
        // telle quelle au lieu de la mélanger : trait clair autour de la toile. 2 px de toile sans lumière = invisible (≈ 4/255).
        var off = lit.parentNode === poster ? (isPoster ? LIT_IN : 2) : 0;
        var t = (off ? 'translate(' + (-off) + 'px,' + (-off) + 'px) ' : '') + css3(inv3(m));
        Array.prototype.forEach.call(lit.children, function(el) { el.style.width = WW + 'px'; el.style.height = WH + 'px'; el.style.transform = t; });
      }
      function quadMatrix(W, H, q) {
        var x0 = q[0][0], y0 = q[0][1], x1 = q[1][0], y1 = q[1][1], x2 = q[2][0], y2 = q[2][1], x3 = q[3][0], y3 = q[3][1];
        var dx1 = x1 - x2, dx2 = x3 - x2, dx3 = x0 - x1 + x2 - x3, dy1 = y1 - y2, dy2 = y3 - y2, dy3 = y0 - y1 + y2 - y3;
        var den = dx1 * dy2 - dx2 * dy1;
        var g = (dx3 * dy2 - dx2 * dy3) / den, h = (dx1 * dy3 - dx3 * dy1) / den;
        var a = x1 - x0 + g * x1, b = x3 - x0 + h * x3, d = y1 - y0 + g * y1, e = y3 - y0 + h * y3;
        return 'matrix3d(' + [a / W, d / W, 0, g / W, b / H, e / H, 0, h / H, 0, 0, 1, 0, x0, y0, 0, 1].join(',') + ')';
      }
      function hull(pts) {
        pts = pts.slice().sort(function(p, q) { return p[0] - q[0] || p[1] - q[1]; });
        var cr = function(o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); };
        var lo = [], up = [], i;
        for (i = 0; i < pts.length; i++) { while (lo.length > 1 && cr(lo[lo.length - 2], lo[lo.length - 1], pts[i]) <= 0) lo.pop(); lo.push(pts[i]); }
        for (i = pts.length - 1; i >= 0; i--) { while (up.length > 1 && cr(up[up.length - 2], up[up.length - 1], pts[i]) <= 0) up.pop(); up.push(pts[i]); }
        return lo.slice(0, -1).concat(up.slice(0, -1));
      }

      // --- Caméra reconstruite à partir du calibrage ---
      // Calibrage : « x,y x,y x,y x,y / L x H / u0,v0 » — 4 coins d'un rectangle
      // du mur (en % de la photo : HG, HD, BD, BG), sa taille réelle en cm, et
      // la position de son coin bas-gauche dans le repère du mur.
      function parseCalib(str, W, H) {
        var parts = String(str || '').split('/');
        if (parts.length < 2) return null;
        var pts = parts[0].trim().split(/\s+/).map(function(p) { return p.split(',').map(Number); });
        var wh = parts[1].toLowerCase().split('x').map(Number);
        var o = (parts[2] || '0,0').split(',').map(Number);
        if (pts.length !== 4 || wh.length !== 2 || isNaN(wh[0]) || isNaN(wh[1])) return null;
        for (var i = 0; i < 4; i++) if (pts[i].length !== 2 || isNaN(pts[i][0]) || isNaN(pts[i][1])) return null;
        return {
          pts: pts.map(function(p) { return [p[0] * W / 100, p[1] * H / 100]; }),
          w: wh[0], h: wh[1], u0: o[0] || 0, v0: o[1] || 0
        };
      }
      function camera(c, W, H) {
        var src = [[c.u0, c.v0 + c.h], [c.u0 + c.w, c.v0 + c.h], [c.u0 + c.w, c.v0], [c.u0, c.v0]];
        var M = homography(src, c.pts), cx = W / 2, cy = H / 2;
        // focale : valable en vue de trois-quarts ; de face, valeur par défaut
        var a0 = M[0][0] - cx * M[2][0], b0 = M[1][0] - cy * M[2][0];
        var a1 = M[0][1] - cx * M[2][1], b1 = M[1][1] - cy * M[2][1];
        var den = M[2][1] * M[2][1] - M[2][0] * M[2][0];
        var f = Math.abs(den) > 1e-14 ? Math.sqrt((a0 * a0 + b0 * b0 - a1 * a1 - b1 * b1) / den) : NaN;
        if (!(f >= 0.7 * W && f <= 2.5 * W)) f = 1.2 * W;
        var Ki = function(v) { return [(v[0] - cx * v[2]) / f, (v[1] - cy * v[2]) / f, v[2]]; };
        var col = function(i) { return [M[0][i], M[1][i], M[2][i]]; };
        var m0 = Ki(col(0)), m1 = Ki(col(1)), m2 = Ki(col(2));
        var nrm = function(v) { return Math.sqrt(v[0] * v[0] + v[1] * v[1] + v[2] * v[2]); };
        var lam = 2 / (nrm(m0) + nrm(m1));
        var sc = function(v, s) { return [v[0] * s, v[1] * s, v[2] * s]; };
        var r1 = sc(m0, lam), r2 = sc(m1, lam), t = sc(m2, lam);
        if (t[2] < 0) { r1 = sc(r1, -1); r2 = sc(r2, -1); t = sc(t, -1); }
        var r3 = [r1[1] * r2[2] - r1[2] * r2[1], r1[2] * r2[0] - r1[0] * r2[2], r1[0] * r2[1] - r1[1] * r2[0]];
        if (-(r3[0] * t[0] + r3[1] * t[1] + r3[2] * t[2]) < 0) r3 = sc(r3, -1);   // w vers la caméra
        return { f: f, cx: cx, cy: cy, r1: r1, r2: r2, r3: r3, t: t };
      }
      function camPoint(k, u, v, w) {
        return [0, 1, 2].map(function(i) { return u * k.r1[i] + v * k.r2[i] + w * k.r3[i] + k.t[i]; });
      }
      function project(k, u, v, w) {
        var P = camPoint(k, u, v, w);
        return [k.cx + k.f * P[0] / P[2], k.cy + k.f * P[1] / P[2]];
      }

      decors = decors.map(function(d) {
        // Réglages avancés (JSON) : caméra déjà calibrée — exprimée pour une image
        // de refW px de large, mise à l'échelle de la photo réelle —, plancher
        // vmin, obstacles, zone repère à garder dans le cadre, netteté lumière.
        var A = {};
        try { A = d.avance ? JSON.parse(d.avance) : {}; } catch (e) { A = {}; }
        if (A.camera && A.camera.r1) {
          var k = A.camera, sc0 = d.W / (+A.refW || d.W);
          d.cam = { f: k.f * sc0, cx: k.cx * sc0, cy: k.cy * sc0, r1: k.r1, r2: k.r2, r3: k.r3, t: k.t };
        } else {
          var c = parseCalib(d.calib, d.W, d.H);
          if (!c) return null;
          d.cam = camera(c, d.W, d.H);
        }
        d.u = +d.u || 0;
        d.vb = isNaN(parseFloat(d.vb)) ? 95 : +d.vb;
        d.vmax = +d.vmax || 220;
        d.vmin = isNaN(parseFloat(A.vmin)) ? Math.min(78, d.vb) : +A.vmin;
        d.obstacles = Array.isArray(A.obstacles) ? A.obstacles : [];
        if (Array.isArray(A.anchorPx) && A.anchorPx.length === 4) {
          var sa = d.W / (+A.refW || d.W);
          d.anchor = A.anchorPx.map(function(v) { return v * sa; });
        }
        d.lightRes = clamp(+A.lightRes || 96, 48, 320);
        // reflet de fenêtre dans la vitre { x, w, ang, a, bar } (% de l'affiche)
        d.reflet = A.reflet && A.reflet.w ? A.reflet : null;
        // épaisseur de la tranche du cadre (cm), par décor : dans les vues très
        // de biais, les 2,5 cm par défaut paraissaient trop épais (user, 12/10)
        d.tranche = +A.tranche || 0;
        // part de la couleur du mur reprise par la lumière posée sur l'affiche
        // (0 = gris neutre, 0,75 par défaut) : murs colorés ou foncés (15/10/2026)
        d.litSat = isNaN(parseFloat(A.litSat)) ? null : +A.litSat;
        // flou de cette lumière (px de la photo) : sur mur foncé, l'éclaircissement fait ressortir le grain du mur
        d.litBlur = +A.litBlur || 0;
        d.litColor = Array.isArray(A.litColor) && A.litColor.length === 3 ? A.litColor : null;
        d.haze = A.haze && Array.isArray(A.haze.c) && +A.haze.a > 0 ? A.haze : null;
        d.artSat = +A.artSat || 0;
        // 16/10/2026 : carte de lumière (image calée sur la photo, tirée du papier blanc de la
        // photo de référence) — remplace litSat / litBlur / litColor / haze / artSat — et
        // reflet de la vitre propre au décor { img, a } (_decors-outils/carte-lumiere.js)
        d.lumiere = typeof A.lumiere === 'string' && A.lumiere ? A.lumiere : null;
        d.vitre = A.vitre && A.vitre.img ? A.vitre : null;
        // couleurs de la pièce calées sur une image de GPT (_decors-outils/calib-gpt.js) : matrice 3 x 4
        // appliquée au design, et sa lumière (image dans le repère de l'affiche) × gain — dans un filtre
        // SVG, qui peut éclaircir (un calque en « produit » ne sait qu'assombrir)
        d.couleurs = Array.isArray(A.couleurs) && A.couleurs.length === 3 ? A.couleurs : null;
        d.lumiereArt = d.couleurs && typeof A.lumiereArt === 'string' && A.lumiereArt ? A.lumiereArt : null;
        d.gain = +A.gain || 1;
        // force de l'ombre portée du cadre (18/10/2026) : sur mur foncé, l'ombre par défaut ne se voyait plus (affiche « collée »)
        d.ombre = +A.ombre || 1;
        // ombre mesurée sur l'image de l'IA (_decors-outils/mesurer-ombre.js) : { x, y, flou, a } en cm (18/10/2026)
        d.ombreIA = A.ombre && typeof A.ombre === 'object' && +A.ombre.a > 0 ? A.ombre : null;
        // clarté du mur autour de l'affiche (0-1), d'après sa couleur mesurée
        // (_mesurer-murs.js) : sert à doser la lumière des affiches (applyLight)
        var mh = /^#?([0-9a-f]{6})$/i.exec(d.mur || A.mur || '');
        d.murL = mh ? (0.2126 * parseInt(mh[1].slice(0, 2), 16) + 0.7152 * parseInt(mh[1].slice(2, 4), 16) + 0.0722 * parseInt(mh[1].slice(4, 6), 16)) / 255 : 0;
        // décor réservé à un format (« 100 x 70 ») : dimensions triées
        d.pour = d.pour ? (readDims(d.pour) || []).sort(function(a, b) { return a - b; }) : null;
        if (d.pour && d.pour.length !== 2) d.pour = null;
        return d;
      });
      // Décor à montrer : celui de la miniature, SAUF si un décor est réservé au
      // format choisi (13/10/2026 : le 100 x 70 dans la même pièce vue de plus loin).
      function decorFor(g) {
        if (view === 'flat') return FLAT;
        var base = decors[+view] || FLAT;
        if (base.flat || !g) return base;
        var a = Math.min(g.w, g.h), b = Math.max(g.w, g.h);
        for (var i = 0; i < decors.length; i++) {
          var d = decors[i];
          if (d && d.pour && Math.abs(d.pour[0] - a) < 0.5 && Math.abs(d.pour[1] - b) < 0.5) return d;
        }
        return base;
      }
      var shownD = null;
      // Vue « Produit » : un mur virtuel de face, sans photo (4 px par cm).
      // vmin obligatoire (plancher ajouté aux décors le 05/10) : sans lui, le
      // calcul de hauteur donnait NaN et l'œuvre restait collée en haut à gauche.
      var FLAT = { flat: true, W: 1000, H: 1250, u: 0, vb: 100, vmin: 100, vmax: 1000, light: 'left' };
      FLAT.cam = camera({ pts: [[300, 600], [700, 600], [700, 800], [300, 800]], w: 100, h: 50, u0: -50, v0: 100 }, 1000, 1250);

      // --- Ce que le client a choisi → dimensions physiques ---
      function selection() {
        var out = { dims: null, frame: 'none' };
        section.querySelectorAll('.ml-variant-group').forEach(function(group) {
          var checked = group.querySelector('.ml-variant-btn__input:checked');
          if (!checked) return;
          if (group.hasAttribute('data-ml-finition')) out.frame = frameKind(checked.value);
          else if (!out.dims) out.dims = readDims(checked.value);
        });
        return out;
      }
      function target() {
        var s = selection(), d = s.dims || [60, 40];
        // Le format s'écrit « grand côté x petit côté » : l'orientation vient
        // du visuel lui-même (plus large que haut = paysage).
        var big = Math.max(d[0], d[1]), small = Math.min(d[0], d[1]), w, h;
        if (Math.abs(artRatio - 1) < 0.04) { w = d[0]; h = d[1]; }
        else if (artRatio > 1) { w = big; h = small; }
        else { w = small; h = big; }
        var framed = s.frame !== 'none', geo = { w: w, h: h };
        // Paramètres physiques par support (cm) — MOCKUP-SPEC.md § 6
        // Affiches (14/10/2026, nouveau fournisseur) : baguette ~0,9 cm de face
        // (cadre = affiche + 1,8 cm), 2,2 cm de profondeur (avant : 2 cm / 2,5 cm).
        if (support === 'affiche') { geo.fw = framed ? 0.9 : 0; geo.gap = 0; geo.depth = framed ? 2.2 : 0.1; }
        else {
          // Toiles (02/11/2026, user) : châssis de 2 cm en 60 x 40, 4 cm pour les grands formats (90 x 60 et plus)
          geo.fw = framed ? 1.2 : 0; geo.gap = framed ? 0.8 : 0; geo.depth = framed ? 4 : (Math.max(w, h) >= 89 ? 4 : 2);
        }
        return { geo: geo, frame: s.frame };
      }

      // --- Lumière de la pièce : 2 cartes floues calculées une fois par décor ---
      function lightMaps(D) {
        D.lm = null;   // en cours
        var im = new Image();
        im.crossOrigin = 'anonymous';
        im.onload = function() {
          try {
            var w = D.lightRes || 96, h = Math.max(1, Math.round(w * im.naturalHeight / im.naturalWidth));
            var c = document.createElement('canvas'); c.width = w; c.height = h;
            var g = c.getContext('2d');
            g.drawImage(im, 0, 0, w, h);
            var px = g.getImageData(0, 0, w, h).data;
            var lum = function(i) { return (0.2126 * px[i] + 0.7152 * px[i + 1] + 0.0722 * px[i + 2]) / 255; };
            // mur moyen : bande haute et centrale de la photo, là où l'on accroche
            var sum = 0, n = 0, x, y;
            for (y = Math.round(h * 0.05); y < Math.round(h * 0.55); y++)
              for (x = Math.round(w * 0.2); x < Math.round(w * 0.8); x++) { sum += lum((y * w + x) * 4); n++; }
            var avg = n ? Math.max(0.2, sum / n) : 0.8;
            // EXPOSITION : le blanc de l'œuvre est calé sur le mur qui l'entoure,
            // +25 %. Ramener le mur au blanc pur laissait l'œuvre en pleine
            // luminosité partout, comme un écran (« ça brille, ça fait fake ») ;
            // +12 % (essai du 04/10) était trop sombre : en déco, on s'attend à un
            // rendu flatteur, et une photo trop terne fait craindre pire en vrai.
            // Pièce claire → quasi pleine luminosité ; pièce sombre → ~8 % de moins.
            // Réglage fin par décor : exposition.
            // Plancher 0,88 (12/10/2026, comme les affiches) : sur un mur sombre
            // (entrée gris-bleu, mur ~0,5) l'œuvre tombait à ~77 % de sa clarté.
            var T = clamp(Math.max(avg * 1.25, 0.88) * (1 + (+D.expo || 0) / 100), 0.4, 0.98);
            var vr = 0, vg = 0, vb2 = 0;
            var tint = g.createImageData(w, h), sun = g.createImageData(w, h);
            for (var i = 0; i < px.length; i += 4) {
              var l = lum(i);
              for (var ch = 0; ch < 3; ch++) {
                var cv = px[i + ch] / 255;
                cv = l + (cv - l) * 0.75;                       // un peu désaturé
                tint.data[i + ch] = Math.min(255, Math.round(cv / avg * T * 255));
              }
              tint.data[i + 3] = 255;
              vr += px[i]; vg += px[i + 1]; vb2 += px[i + 2];
              var sv = clamp(0.5 + (l / avg * 0.5 - 0.5) * 2.4, 0, 1);
              sun.data[i] = sun.data[i + 1] = sun.data[i + 2] = Math.round(sv * 255);
              sun.data[i + 3] = 255;
            }
            g.putImageData(tint, 0, 0); var a = c.toDataURL('image/png');
            g.putImageData(sun, 0, 0); var b = c.toDataURL('image/png');
            var np = px.length / 4;
            D.lm = { a: a, b: b, veil: 'rgb(' + Math.round(vr / np) + ',' + Math.round(vg / np) + ',' + Math.round(vb2 / np) + ')' };
          } catch (e) { D.lm = false; }     // photo illisible : repli CSS
          layout();
        };
        im.onerror = function() { D.lm = false; layout(); };
        im.src = D.small;
      }
      // filtre SVG des couleurs du décor (16/10/2026), créé une fois, mis à jour à chaque mise en page
      var fx = null;
      function artColors(D) {
        var lift = live.querySelector('.ml-live__lift');
        if (D.flat || !D.couleurs) {
          artImg.style.filter = '';
          if (lift) lift.style.display = '';
          return;
        }
        var NS = 'http://www.w3.org/2000/svg';
        if (!fx) {
          var svg = document.createElementNS(NS, 'svg');
          svg.setAttribute('aria-hidden', 'true');
          svg.setAttribute('width', '0'); svg.setAttribute('height', '0');
          svg.style.position = 'absolute';
          fx = { id: 'ml-fx-' + Math.random().toString(36).slice(2), svg: svg };
          fx.f = document.createElementNS(NS, 'filter');
          fx.f.setAttribute('id', fx.id);
          fx.f.setAttribute('color-interpolation-filters', 'sRGB');
          fx.f.setAttribute('filterUnits', 'userSpaceOnUse');
          fx.f.setAttribute('primitiveUnits', 'userSpaceOnUse');
          fx.m = document.createElementNS(NS, 'feColorMatrix');
          fx.m.setAttribute('type', 'matrix'); fx.m.setAttribute('in', 'SourceGraphic'); fx.m.setAttribute('result', 'c');
          fx.i = document.createElementNS(NS, 'feImage');
          fx.i.setAttribute('preserveAspectRatio', 'none'); fx.i.setAttribute('result', 'l');
          fx.k = document.createElementNS(NS, 'feComposite');
          fx.k.setAttribute('in', 'c'); fx.k.setAttribute('in2', 'l'); fx.k.setAttribute('operator', 'arithmetic');
          fx.f.appendChild(fx.m); fx.f.appendChild(fx.i); fx.f.appendChild(fx.k);
          svg.appendChild(fx.f);
          live.appendChild(svg);
        }
        var w = artImg.offsetWidth, h = artImg.offsetHeight, F = D.couleurs;
        ['x', 'y'].forEach(function(a) { fx.f.setAttribute(a, '0'); fx.i.setAttribute(a, '0'); });
        fx.f.setAttribute('width', w); fx.f.setAttribute('height', h);
        fx.i.setAttribute('width', w); fx.i.setAttribute('height', h);
        fx.m.setAttribute('values', [F[0][0], F[0][1], F[0][2], 0, F[0][3], F[1][0], F[1][1], F[1][2], 0, F[1][3], F[2][0], F[2][1], F[2][2], 0, F[2][3], 0, 0, 0, 1, 0].join(' '));
        // sans carte : la composition « arithmétique » rend la couleur seule (k2 = 1)
        var g = D.gain * (1 + (+D.expo || 0) / 100);
        if (D.lumiereArt) fx.i.setAttribute('href', D.lumiereArt); else fx.i.removeAttribute('href');
        fx.k.setAttribute('k1', D.lumiereArt ? g : 0); fx.k.setAttribute('k2', D.lumiereArt ? 0 : g);
        fx.k.setAttribute('k3', 0); fx.k.setAttribute('k4', 0);
        artImg.style.filter = 'url(#' + fx.id + ')';
        // noirs : déjà relevés par la matrice
        if (lift) lift.style.display = 'none';
      }
      function applyLight(D) {
        if (isPoster) artColors(D);
        // saturation de l'affiche accordée à celle de la photo du décor (15/10/2026), 1 = inchangée
        live.style.setProperty('--art-s', !D.flat && D.artSat ? D.artSat : 1);
        live.style.setProperty('--ombre', !D.flat && D.ombre ? D.ombre : 1);
        var oi = !D.flat && D.ombreIA;
        live.classList.toggle('has-ombre-ia', !!oi);
        if (oi) { live.style.setProperty('--om-x', +oi.x || 0); live.style.setProperty('--om-y', +oi.y || 0); live.style.setProperty('--om-b', 2 * (+oi.flou || 1)); live.style.setProperty('--om-a', Math.min(0.9, +oi.a)); }
        if (D.flat) return;
        var each = function(list, fn) { Array.prototype.forEach.call(list, fn); };
        if (isPoster) {
          // Affiches : la photo du décor elle-même, en « produit », recalée pile
          // sur l'affiche et son cadre — ombres de feuillage et teinte chaude du
          // mur passent dessus (filtre et opacité : CSS « Réalisme affiche »).
          // Dosage (12/10/2026, user : Sérac « trop sombre ») : la photo était
          // éclaircie de 16 % partout. Sur un mur moyen (sauge, grège) le mur
          // restait vers 70 % → l'affiche perdait ~25 % de luminosité. Le mur
          // est maintenant ramené vers 88 % avant le contraste ; jamais moins
          // que l'ancien 1,16 (rendu des pièces claires inchangé).
          // Plafond 1,6 → 5 (15/10/2026) : murs foncés (bleu nuit, vert sapin) ;
          // aucun mur d'avant n'était sous 0,55 de clarté, rendu inchangé pour eux.
          each(live.querySelectorAll('.ml-live__light--glass'), function(el) {
            el.classList.toggle('is-on', !!D.vitre);
            if (D.vitre) { el.style.backgroundImage = 'url("' + D.vitre.img + '")'; el.style.setProperty('--glass-a', +D.vitre.a || 0.2); }
          });
          if (D.lumiere) {
            // un blanc d'affiche = le papier de l'IA à cet endroit ; exposition = réglage fin
            each(lights.tint, function(el) { el.classList.remove('is-raw'); el.classList.add('is-map'); el.style.backgroundImage = 'url("' + D.lumiere + '")'; el.style.setProperty('--map-b', (1 + (+D.expo || 0) / 100).toFixed(3)); });
            each(lights.sun, function(el) { el.classList.remove('is-haze'); el.style.display = 'none'; });
            each(lights.veil, function(el) { el.classList.remove('is-tint'); el.style.display = 'none'; });
            return;
          }
          each(lights.tint, function(el) { el.classList.remove('is-map'); });
          var lb = D.murL ? clamp(0.88 / D.murL, 1.16, 5) : 1.16;
          lb *= 1 + (+D.expo || 0) / 100;
          each(lights.tint, function(el) { el.classList.add('is-raw'); el.style.backgroundImage = 'url("' + D.bg + '")'; el.style.setProperty('--lit-b', lb.toFixed(3)); if (D.litSat !== null) el.style.setProperty('--lit-s', D.litSat); else el.style.removeProperty('--lit-s'); if (D.litBlur) el.style.setProperty('--lit-blur', D.litBlur + 'px'); else el.style.removeProperty('--lit-blur'); });
          // voile de la pièce (lumière diffuse qui éclaircit les noirs), couleur du papier de la réf. (15/10/2026)
          each(lights.sun, function(el) {
            if (D.haze) { el.classList.add('is-haze'); el.style.setProperty('--haze-c', 'rgb(' + D.haze.c.join(',') + ')'); el.style.setProperty('--haze-a', D.haze.a); el.style.display = 'block'; }
            else { el.classList.remove('is-haze'); el.style.display = 'none'; }
          });
          // teinte de la lumière de la pièce (« produit » par une couleur), mesurée sur le
          // papier du cadre de l'IA de la photo de référence (15/10/2026) ; sinon rien
          each(lights.veil, function(el) {
            if (D.litColor) { el.classList.add('is-tint'); el.style.setProperty('--lit-c', 'rgb(' + D.litColor.join(',') + ')'); el.style.display = 'block'; }
            else { el.classList.remove('is-tint'); el.style.display = 'none'; }
          });
          return;
        }
        if (D.lm === undefined) lightMaps(D);
        if (D.lm) {
          each(lights.tint, function(el) { el.classList.remove('is-raw'); el.style.backgroundImage = 'url("' + D.lm.a + '")'; });
          each(lights.sun, function(el) { el.style.backgroundImage = 'url("' + D.lm.b + '")'; el.style.display = ''; });
          each(lights.veil, function(el) { el.style.backgroundColor = D.lm.veil; el.style.display = ''; });
        } else {
          each(lights.tint, function(el) { el.classList.add('is-raw'); el.style.backgroundImage = 'url("' + D.bg + '")'; });
          each(lights.sun, function(el) { el.style.display = 'none'; });
          each(lights.veil, function(el) { el.style.display = 'none'; });
        }
      }

      // --- Mise en place de toute la scène ---
      var cur = null, goal = null, anim = 0;
      function layout() {
        if (!cur || !goal) return;
        var SW = box.clientWidth, SH = box.clientHeight;
        if (!SW || !SH) return;
        var D = decorFor(goal.geo);
        shownD = D;
        var flat = !!D.flat, frame = goal.frame, framed = frame !== 'none';
        // le décor couvre toujours tout le cadre de la galerie
        var ar = D.W / D.H, WH = Math.max(SH, SW / ar), WW = WH * ar, q = WW / D.W, R = WW / 175;
        // NETTETÉ (06/10/2026) : l'affiche est dessinée à R px par cm PUIS posée
        // en perspective. R valait juste WW/175 (~3 px/cm sur téléphone) :
        // l'affiche était agrandie ×2-3 après coup, donc floue — d'autant plus
        // que le format est grand. On la dessine à la vraie taille écran
        // (px par cm mesurés sur la photo, × densité de l'écran, avec marge).
        var dprR = window.devicePixelRatio || 1;
        var p0 = project(D.cam, D.u || 0, 50, 0), p1 = project(D.cam, (D.u || 0) + 10, 50, 0);
        var screenCm = Math.sqrt(Math.pow(p1[0] - p0[0], 2) + Math.pow(p1[1] - p0[1], 2)) / 10 * q;
        if (screenCm > 0 && isFinite(screenCm)) R = Math.min(60, Math.max(R, screenCm * 1.25 * dprR));
        var dpr = window.devicePixelRatio || 1;
        var need = Math.min(2400, Math.ceil(WW * dpr * 1.6 / 200) * 200);
        if (!flat && !D.bg) {
          // une seule taille de photo par décor : de quoi tenir le zoom
          D.bg = D.img.replace(/([?&]width=)\d+/, '$1' + need);
          D.bgW = need;
        } else if (!flat && need > (D.bgW || 0) && !D.bgLoad) {
          // grand aperçu (02/11/2026) : photo plus grande chargée À CÔTÉ, puis échangée (pas de mur blanc entre les deux)
          var bigUrl = D.img.replace(/([?&]width=)\d+/, '$1' + need), bigIm = new Image(), DD = D;
          DD.bgLoad = true;
          bigIm.onload = function() { DD.bg = bigUrl; DD.bgW = need; DD.bgLoad = false; layout(); };
          bigIm.onerror = function() { DD.bgW = need; DD.bgLoad = false; };
          bigIm.src = bigUrl;
        }
        // décors réservés à un format : photo chargée d'avance, discrètement,
        // pour que le fondu soit immédiat le jour où on choisit ce format
        if (!flat && !layout.pre) {
          layout.pre = true;
          decors.forEach(function(d) {
            if (!d || !d.pour || d.bg) return;
            var nd = Math.min(2400, Math.ceil(WW * dpr * 1.6 / 200) * 200);
            d.bg = d.img.replace(/([?&]width=)\d+/, '$1' + nd); d.bgW = nd;
            setTimeout(function() { new Image().src = d.bg; }, 1500);
          });
        }
        var pr = function(u, v, w) { var p = project(D.cam, u, v, w); return [p[0] * q, p[1] * q]; };
        var fw = cur.fw, gp = cur.gap, depth = isPoster && fw > 0 && D.tranche ? D.tranche : cur.depth;
        var pwc = cur.w + 2 * (fw + gp), phc = cur.h + 2 * (fw + gp);
        // bas de l'œuvre à la hauteur prévue ; on descend si le mur visible manque de hauteur
        var vb = Math.max(D.vmin, Math.min(D.vb, D.vmax - phc - 3));
        // Toiles (02/11/2026, user) : avec ou sans cadre, la TOILE ne bouge pas — le cadre pousse autour d'elle.
        // Place calculée pour la toile seule, cadre de 2 cm réservé (1,2 + 0,8), puis cadre ajouté autour.
        if (!isPoster) vb = Math.max(D.vmin, Math.min(D.vb, D.vmax - cur.h - 4 - 3)) - (fw + gp);
        var uL = D.u - pwc / 2, uR = D.u + pwc / 2;
        // obstacle (lampe…) sous l'œuvre : on la remonte au-dessus
        (D.obstacles || []).forEach(function(o) {
          if (uR > o.u0 - 2 && uL < o.u1 + 2) vb = Math.max(vb, (+o.topV || 0) + 5);
        });
        var vT = vb + phc;
        var front = [pr(uL, vT, depth), pr(uR, vT, depth), pr(uR, vb, depth), pr(uL, vb, depth)];
        var back = [pr(uL, vT, 0), pr(uR, vT, 0), pr(uR, vb, 0), pr(uL, vb, 0)];
        var PW = pwc * R, PH = phc * R;

        world.style.width = WW + 'px';
        world.style.height = WH + 'px';
        world.style.setProperty('--cm', R + 'px');
        world.style.setProperty('--prof', depth.toFixed(2));   // épaisseur de l'œuvre (cm) : ombre des toiles
        world.style.setProperty('--sx', D.light === 'right' ? -1 : D.light === 'front' ? 0 : 1);
        world.style.backgroundImage = flat ? 'none' : 'url("' + D.bg + '")';
        live.classList.toggle('is-flat', flat);
        live.classList.toggle('is-framed', framed);

        // Toiles (02/11/2026, « bords qui grésillent ») : pendant un changement de taille, la toile est dessinée UNE fois
        // à sa taille d'arrivée et seulement agrandie / réduite par la transformation (kS) — le navigateur ne la redessine
        // plus à chaque image (bords qui sautaient de pixel en pixel, et plus léger sur téléphone). Formats d'un même
        // visuel = mêmes proportions (60 x 40, 90 x 60, 120 x 80), donc rien n'est déformé.
        var kS = !isPoster && goal && goal.geo ? (goal.geo.w + 2 * (fw + gp)) / pwc : 1;
        if (!(kS > 0) || !isFinite(kS)) kS = 1;
        // Toiles : largeur / hauteur dessinées en pixels ENTIERS. Sinon les bords droit et bas tombent au milieu d'un
        // pixel qui change à chaque image : les calques s'y mélangent mal et il clignote du clair au foncé (user, 02/11/2026).
        var EW = isPoster ? PW * kS : Math.max(1, Math.round(PW * kS)), EH = isPoster ? PH * kS : Math.max(1, Math.round(PH * kS));
        poster.style.width = EW + 'px';
        poster.style.height = EH + 'px';
        poster.style.padding = (fw * R * kS) + 'px';
        poster.style.background = framed ? (FRAMES[frame] || FRAMES.black) : 'transparent';
        if (isPoster) {
          var P = poster.style, F = fw * R;
          P.setProperty('--F', F + 'px');
          if (framed) {
            // éclairage par baguette : haut +10 %, bas -13 %, côté lumière +6 %,
            // côté opposé -9 % (cadre noir : 7 / 10 / 5 / 8 %)
            var dark = frame === 'black', sxv = D.light === 'right' ? -1 : 1;
            var hi = function(a) { return 'rgba(255,255,255,' + a + ')'; }, lo = function(a) { return 'rgba(0,0,0,' + a + ')'; };
            var tk = frame === 'black' ? 'Noir' : frame === 'oak-light' ? 'Chene' : '';
            var th = tk && live.dataset['tex' + tk + 'H'], tv = tk && live.dataset['tex' + tk + 'V'];
            P.setProperty('--fbg', FRAMES[frame] || FRAMES.black);
            P.setProperty('--gH', th ? 'url("' + th + '")' : 'none');
            P.setProperty('--gV', tv ? 'url("' + tv + '")' : 'none');
            P.setProperty('--lt', hi(dark ? 0.07 : 0.10));
            P.setProperty('--lb', lo(dark ? 0.10 : 0.13));
            P.setProperty('--ll', sxv > 0 ? hi(dark ? 0.05 : 0.06) : lo(dark ? 0.08 : 0.09));
            P.setProperty('--lr', sxv > 0 ? lo(dark ? 0.08 : 0.09) : hi(dark ? 0.05 : 0.06));
            miterPath.parentNode.setAttribute('viewBox', '0 0 ' + PW + ' ' + PH);
            miterPath.setAttribute('d', 'M0 0L' + F + ' ' + F + 'M' + PW + ' 0L' + (PW - F) + ' ' + F + 'M' + PW + ' ' + PH + 'L' + (PW - F) + ' ' + (PH - F) + 'M0 ' + PH + 'L' + F + ' ' + (PH - F));
            miterPath.setAttribute('stroke', dark ? 'rgba(255,255,255,.07)' : 'rgba(40,22,8,.28)');
            miterPath.setAttribute('stroke-width', 0.035 * R);
          }
          var rf = !flat && framed && !D.vitre && D.reflet;
          live.classList.toggle('has-refl', !!rf);
          if (rf) {
            P.setProperty('--rx', rf.x); P.setProperty('--rw', rf.w); P.setProperty('--rang', rf.ang + 'deg');
            P.setProperty('--ra', rf.a); P.setProperty('--rbar', rf.bar);
          }
          // Netteté accordée à la photo : flou de 0,3 px de la photo du décor,
          // ramené à l'échelle de l'affiche (cadre compris). Rien sur fond uni.
          var photoPxCm = Math.sqrt(Math.pow(front[1][0] - front[0][0], 2) + Math.pow(front[1][1] - front[0][1], 2)) / q / pwc;
          var blurPx = flat || coarse ? '' : 'blur(' + (0.3 / photoPxCm * R).toFixed(2) + 'px)';
          P.filter = blurPx;
          side.style.filter = blurPx;
        }
        var Hp = quadH(EW, EH, front);
        poster.style.transform = css3(Hp);
        placeLit(posterLit, Hp, WW, WH);
        gapEl.style.padding = (gp * R * kS) + 'px';
        shadowEl.style.width = PW + 'px';
        shadowEl.style.height = PH + 'px';
        shadowEl.style.transform = quadMatrix(PW, PH, back);

        // Tranche (épaisseur du cadre ou du châssis) : la face gauche ou droite
        // qui regarde la caméra, s'il y en a une. Rien en vue de face.
        var sidePts = [], showSide = false;
        if (depth > 0.5) {
          var vm = (vb + vT) / 2, k = D.cam;
          var pR = camPoint(k, uR, vm, depth / 2), pL = camPoint(k, uL, vm, depth / 2);
          var seeR = -(k.r1[0] * pR[0] + k.r1[1] * pR[1] + k.r1[2] * pR[2]) > 0;
          var seeL = (k.r1[0] * pL[0] + k.r1[1] * pL[1] + k.r1[2] * pL[2]) > 0;
          if (seeR || seeL) {
            // Affiches (12/10/2026) : la tranche passe 0,3 cm SOUS la face avant
            // et 0,2 cm « dans » le mur. Bord à bord, les deux pixels de jonction
            // à moitié transparents (flou de netteté) laissaient voir le mur :
            // liseré clair le long du cadre, « fait à la va-vite » (user).
            var ov = isPoster && framed ? 0.3 : 0, wb = isPoster && framed ? -0.2 : 0;
            var sq = seeR
              ? [pr(uR - ov, vT, depth), pr(uR, vT, wb), pr(uR, vb, wb), pr(uR - ov, vb, depth)]
              : [pr(uL, vT, wb), pr(uL + ov, vT, depth), pr(uL + ov, vb, depth), pr(uL, vb, wb)];
            if (Math.abs(sq[0][0] - sq[1][0]) > 0.8) {
              showSide = true;
              sidePts = sq;
              var SWd = depth * R;
              side.style.width = SWd + 'px';
              side.style.height = PH + 'px';
              var Hs = quadH(SWd, PH, sq);
              side.style.transform = css3(Hs);
              placeLit(sideLit, Hs, WW, WH);
              // Affiches : ombrage plus doux et vrai fil du bois (texture des
              // baguettes, dans la longueur) au lieu du faux bois rayé, qui
              // donnait une bande gris-vert sur le chêne (12/10/2026).
              var sA = isPoster ? (frame === 'black' ? 0.18 : 0.10) : 0.26, sB = isPoster ? (frame === 'black' ? 0.30 : 0.22) : 0.40;
              var dark = seeR ? 'linear-gradient(90deg,rgba(0,0,0,' + sA + '),rgba(0,0,0,' + sB + '))' : 'linear-gradient(90deg,rgba(0,0,0,' + sB + '),rgba(0,0,0,' + sA + '))';
              var tkS = frame === 'black' ? 'Noir' : frame === 'oak-light' ? 'Chene' : '', grain = isPoster && tkS && live.dataset['tex' + tkS + 'V'];
              side.style.background = framed
                ? dark + ',' + (grain ? 'url("' + grain + '") 0 0/' + (4 * R) + 'px ' + (40 * R) + 'px repeat,' : '') + (FRAMES[frame] || FRAMES.black)
                : dark + ',url("' + (artImg.currentSrc || artImg.src) + '") ' + (seeR ? 'right' : 'left') + ' center/' + (cur.w * R) + 'px ' + (cur.h * R) + 'px no-repeat';
            }
          }
        }
        side.style.display = showSide ? 'block' : 'none';

        applyLight(D);

        // Caméra : on s'approche des petits formats, on recule pour les grands,
        // sans jamais montrer le bord de la photo — ni l'agrandir au point
        // qu'elle devienne floue.
        var xs = front.map(function(p) { return p[0]; }), ys = front.map(function(p) { return p[1]; });
        var bx0 = Math.min.apply(null, xs), bx1 = Math.max.apply(null, xs);
        var by0 = Math.min.apply(null, ys), by1 = Math.max.apply(null, ys);
        var cx = (bx0 + bx1) / 2, cy = (by0 + by1) / 2, z, tx, ty;
        var flatArt = parseFloat(live.dataset.flatArt);
        if (flat && flatArt) {
          // Images fixes (_generer-mockups.js) : le grand côté de l'ŒUVRE, cadre
          // non compris, occupe une part fixe de l'image — le gabarit du catalogue.
          var artW = (bx1 - bx0) * cur.w / pwc, artH = (by1 - by0) * cur.h / phc;
          z = flatArt * Math.min(SW, SH) / Math.max(artW, artH);
          tx = SW / 2 - z * cx; ty = SH / 2 - z * cy;
        } else if (flat) {
          z = Math.min(SW * 0.74 / (bx1 - bx0), SH * 0.62 / (by1 - by0));
          tx = SW / 2 - z * cx; ty = SH / 2 - z * cy;
        } else if (support === 'affiche' || support === 'toile') {   // toiles (02/11/2026) : même cadrage fixe, un seul décor
          // Affiches (06/10/2026, demande user) : la pièce ne bouge PAS, seule
          // l'affiche change de taille — c'est elle qui donne l'échelle. Photo
          // entière, centrée, sans zoom (les décors d'affiche sont en 4:5).
          // Cadrage FIXE, centré, quelle que soit l'affiche (une photo un peu
          // plus haute que le cadre 4:5 est rognée pareil en haut et en bas) :
          // si on suivait l'affiche, la pièce bougeait d'un format à l'autre.
          z = 1;
          tx = (SW - WW) / 2;
          ty = (SH - WH) / 2;
          // grand aperçu (02/11/2026) : l'écran ne montre qu'une partie de la photo → centré sur l'œuvre, sans sortir de la photo
          // grand aperçu : même cadrage que dans la page, PAS de zoom (user : les repères du bas et des côtés doivent rester) — seul le cadre est plus grand
        } else {
          var tg = goal.geo, bigc = Math.max(tg.w, tg.h) + 2 * (tg.fw + tg.gap);
          var zmax = clamp(D.W * 1.6 / (WW * dpr), 1, 2.4);
          z = clamp(Math.pow(125 / bigc, 0.8), 1, zmax);
          var ccx = cx, ccy = cy, cyPart = 0.42;
          if (D.anchor) {
            // zone repère (meuble, lampe…) : toujours dans le cadre avec l'œuvre
            var ux0 = Math.min(bx0, D.anchor[0] * q), uy0 = Math.min(by0, D.anchor[1] * q);
            var ux1 = Math.max(bx1, D.anchor[2] * q), uy1 = Math.max(by1, D.anchor[3] * q);
            z = Math.max(1, Math.min(z, SW * 0.94 / (ux1 - ux0), SH * 0.94 / (uy1 - uy0)));
            ccx = (ux0 + ux1) / 2; ccy = (uy0 + uy1) / 2; cyPart = 0.5;
          }
          tx = clamp(SW / 2 - z * ccx, SW - z * WW, 0);
          ty = clamp(SH * cyPart - z * ccy, SH - z * WH, 0);
        }
        world.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + z + ')';

        if (caption) {
          var g2 = goal.geo;
          // 20/10/2026 : n'écrire la légende que si elle change. La réécrire à chaque image de l'animation
          // (même texte) faisait recalculer TOUTE la page par les règles « :has() » du thème (≈ 725 éléments
          // × 60 fois/s) : la vraie cause des saccades et de la lenteur sur téléphone.
          var capTxt = fmt(g2.w) + ' × ' + fmt(g2.h) + ' cm' + (!flat && D.label ? ' · ' + D.label : '');
          if (caption.textContent !== capTxt) caption.textContent = capTxt;
        }
        if (isPoster) { clearTimeout(layout.mt); layout.mt = setTimeout(updateMini, 150); }
      }

      // Miniature « Au mur » des affiches (13/10/2026, user : la pièce vide
      // « fait bugué ») : copie réduite de la scène en direct, affiche comprise,
      // refaite quand la scène a fini de bouger.
      function updateMini() {
        if (view === 'flat') return;
        var th = section.querySelector('.ml-product__thumb--decor[data-live-view="' + view + '"]');
        var SW = box.clientWidth, SH = box.clientHeight;
        if (!th || !SW || !SH || !th.clientWidth) return;
        // 20/10/2026 (lenteur sur téléphone) : recopier la scène fait recalculer TOUTE la page (règles :has du
        // thème). On ne la recopie que si la vignette est à l'écran et que l'aperçu a changé depuis la dernière copie.
        var miniKey = view + '|' + JSON.stringify(goal && goal.geo) + '|' + (goal && goal.frame) + '|' + SW + 'x' + SH;
        var tr = th.getBoundingClientRect();
        if (tr.bottom < 0 || tr.top > (window.innerHeight || 800)) { updateMini.dirty = true; return; }
        if (th.__miniKey === miniKey && th.querySelector('.ml-thumb-mini')) return;
        th.__miniKey = miniKey; updateMini.dirty = false;
        var mini = th.querySelector('.ml-thumb-mini');
        if (!mini) {
          mini = document.createElement('span');
          mini.className = 'ml-thumb-mini';
          mini.setAttribute('aria-hidden', 'true');
          th.appendChild(mini);
        }
        var tw = th.clientWidth, thh = th.clientHeight, sc = Math.max(tw / SW, thh / SH);
        var liveCls = 'ml-live ml-thumb-mini__in ' + Array.prototype.filter.call(live.classList, function(k) { return /^(is-framed|is-flat|has-)/.test(k); }).join(' ');
        var inStyle = 'width:' + SW + 'px;height:' + SH + 'px;transform:translate(' + ((tw - SW * sc) / 2) + 'px,' + ((thh - SH * sc) / 2) + 'px) scale(' + sc + ')';
        // 20/10/2026 : si la copie existe déjà avec la même structure, on recopie seulement classes et styles
        // (aucun élément ajouté ni retiré → pas de recalcul de toute la page).
        var old = mini.firstChild, oc = old && old.firstChild;
        if (old && oc) {
          var src = [world].concat(Array.prototype.slice.call(world.querySelectorAll('*'))), dst = [oc].concat(Array.prototype.slice.call(oc.querySelectorAll('*')));
          if (src.length === dst.length && src.every(function(e, k) { return e.tagName === dst[k].tagName; })) {
            src.forEach(function(e, k) {
              var d = dst[k], st = e.getAttribute('style') || '', cl = e.getAttribute('class') || '';
              if (k === 0) { st = st.replace(/transition:[^;]*;?/g, '') + ';transition:none'; cl = cl.replace(/is-cut/, '').trim(); }
              if ((d.getAttribute('style') || '') !== st) d.setAttribute('style', st);
              if ((d.getAttribute('class') || '') !== cl) d.setAttribute('class', cl);
              if (e.tagName === 'IMG' && d.getAttribute('src') !== e.getAttribute('src')) d.setAttribute('src', e.getAttribute('src'));
            });
            if (old.className !== liveCls) old.className = liveCls;
            old.setAttribute('data-support', live.getAttribute('data-support'));
            old.style.cssText = inStyle;
            return;
          }
        }
        var c = world.cloneNode(true);
        c.removeAttribute('data-ml-world');
        Array.prototype.forEach.call(c.querySelectorAll('[data-ml-shadow],[data-ml-side],[data-ml-poster],[data-ml-gap]'), function(e) {
          ['data-ml-shadow', 'data-ml-side', 'data-ml-poster', 'data-ml-gap'].forEach(function(a) { e.removeAttribute(a); });
        });
        c.classList.remove('is-cut');
        c.style.transition = 'none';
        var tw = th.clientWidth, thh = th.clientHeight, sc = Math.max(tw / SW, thh / SH);
        // la copie garde les classes de l'aperçu (styles « affiche », cadre, reflet)
        var inner = document.createElement('div');
        inner.className = 'ml-live ml-thumb-mini__in ' + Array.prototype.filter.call(live.classList, function(k) { return /^(is-framed|is-flat|has-)/.test(k); }).join(' ');
        inner.setAttribute('data-support', live.getAttribute('data-support'));
        inner.style.cssText = 'width:' + SW + 'px;height:' + SH + 'px;transform:translate(' + ((tw - SW * sc) / 2) + 'px,' + ((thh - SH * sc) / 2) + 'px) scale(' + sc + ')';
        inner.appendChild(c);
        mini.textContent = '';
        mini.appendChild(inner);
      }

      // Animation : on interpole les MESURES (pas les matrices, qui se
      // désaligneraient) et on recalcule toute la scène à chaque image.
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function animateTo(g) {
        // Toiles, téléphone (02/11/2026, user) : au TOUT PREMIER choix, si l'aperçu est sorti de l'écran, la page
        // remonte en douceur jusqu'à lui pour qu'on voie la toile changer ; l'animation part une fois arrivé.
        // Une seule fois par visite de la fiche : les choix suivants ne bougent plus la page.
        if (!isPoster && cur && !animateTo.remonte && window.matchMedia('(max-width: 989px)').matches) {
          animateTo.remonte = true;
          var rl = live.getBoundingClientRect(), haut = 70;
          if (rl.top < haut - rl.height * 0.4 || rl.top > window.innerHeight - rl.height * 0.4) {
            // Défilement maison (le « smooth » du navigateur était trop brusque, user 02/11) : 0,5 s (1 s jugée trop longue, user 02/11 soir), départ et
            // arrivée en douceur ; s'arrête net si le client touche l'écran ou la molette pendant la remontée.
            var y0 = window.pageYOffset, dy = Math.max(0, y0 + rl.top - haut) - y0, t0s = performance.now(), DUREE = reduce ? 0 : 500, stopS = false;
            var arret = function() { stopS = true; };
            window.addEventListener('touchstart', arret, { passive: true });
            window.addEventListener('wheel', arret, { passive: true });
            var pas = function() {
              var k = DUREE ? Math.min(1, (performance.now() - t0s) / DUREE) : 1;
              var e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
              if (!stopS) window.scrollTo({ top: y0 + dy * e, behavior: 'instant' });
              if (k < 1 && !stopS) { requestAnimationFrame(pas); return; }
              window.removeEventListener('touchstart', arret); window.removeEventListener('wheel', arret);
              animateTo(target());
            };
            requestAnimationFrame(pas);
            return;
          }
        }
        var prev = goal;
        goal = g;
        // Toiles (02/11/2026, user) : changer de cadre sans changer de format = simple bascule, sans animation
        var sameSize = prev && prev.geo && Math.abs(prev.geo.w - g.geo.w) < 0.01 && Math.abs(prev.geo.h - g.geo.h) < 0.01;
        if (!isPoster && sameSize && cur) { cancelAnimationFrame(anim); cur = Object.assign({}, g.geo); layout(); return; }
        if (!cur || reduce) { cur = Object.assign({}, g.geo); layout(); return; }
        var from = Object.assign({}, cur), t0 = performance.now(), DUR = 750;   // 02/11/2026 (user) : 420 ms en sortie rapide = « rebondit », « hyper léger »
        cancelAnimationFrame(anim);
        var step = function(now) {
          // 02/11/2026 soir (user : « léger décalage entre le clic et le début de l'animation », surtout téléphone) : la courbe
          // « départ ET arrivée en douceur » restait quasi immobile ~130 ms (moins d'1 px en 100 ms). Moitié douce / moitié
          // « départ franc » : ça bouge dès la 1re image, l'arrivée reste en douceur, même durée.
          var k = Math.min(1, (now - t0) / DUR), e = 0.5 * (k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2) + 0.5 * (1 - Math.pow(1 - k, 3));
          for (var key in g.geo) cur[key] = from[key] + (g.geo[key] - from[key]) * e;
          layout();
          if (k < 1) anim = requestAnimationFrame(step);
        };
        step(t0);
      }

      // Miniatures « décor » et « Produit » : changent de vue sans animation de caméra.
      section.querySelectorAll('[data-live-view]').forEach(function(b) {
        b.addEventListener('click', function() {
          view = b.getAttribute('data-live-view');
          world.classList.add('is-cut');
          layout();
          requestAnimationFrame(function() { requestAnimationFrame(function() { world.classList.remove('is-cut'); }); });
        });
      });
      // Changement de format qui change de décor (100 x 70 → pièce vue de plus
      // loin) : FONDU. Copie de la scène actuelle posée par-dessus, qui
      // s'efface pendant que la nouvelle s'affiche directement à sa taille.
      section.addEventListener('change', function() {
        var g = target();
        if (shownD && cur && decorFor(g.geo) !== shownD) {
          var ghost = world.cloneNode(true);
          ghost.removeAttribute('data-ml-world');
          ghost.querySelectorAll('[data-ml-shadow],[data-ml-side],[data-ml-poster],[data-ml-gap]').forEach(function(e) {
            ['data-ml-shadow', 'data-ml-side', 'data-ml-poster', 'data-ml-gap'].forEach(function(a) { e.removeAttribute(a); });
          });
          ghost.setAttribute('aria-hidden', 'true');
          ghost.classList.add('ml-live__world--ghost');
          world.parentNode.insertBefore(ghost, world.nextSibling);
          cancelAnimationFrame(anim);
          goal = g; cur = Object.assign({}, g.geo);
          world.classList.add('is-cut');
          layout();
          requestAnimationFrame(function() { requestAnimationFrame(function() {
            world.classList.remove('is-cut');
            ghost.style.opacity = '0';
          }); });
          setTimeout(function() { if (ghost.parentNode) ghost.parentNode.removeChild(ghost); }, reduce ? 0 : 450);
          return;
        }
        animateTo(g);
      });
      var ro = 'ResizeObserver' in window ? new ResizeObserver(function() { layout(); }) : null;
      (function() {
        var strip = section.querySelector('.ml-product__thumb--decor');
        if (!strip || !('IntersectionObserver' in window)) return;
        new IntersectionObserver(function(es) { if (es[0].isIntersecting && updateMini.dirty) updateMini(); }).observe(strip);
      })();
      if (ro) ro.observe(box);
      else window.addEventListener('resize', layout);

      // GRAND APERÇU (02/11/2026, user : l'aperçu est « assez dézoomé, obligé pour tout faire rentrer ») : un appui
      // sur l'aperçu (ou sur le bouton en haut à droite) l'ouvre en plein écran. C'est le MÊME élément, déplacé dans
      // la visionneuse puis remis à sa place (comme le bandeau téléphone) : un seul moteur, rien à tenir à jour.
      (function bigView() {
        var btn = live.querySelector('[data-ml-live-big]');
        if (!btn) return;
        var ov = document.createElement('div');
        ov.className = 'ml-live-big';
        ov.setAttribute('aria-hidden', 'true');
        ov.innerHTML = '<div class="ml-live-big__box"></div><button type="button" class="ml-live-big__close"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M5 5l10 10M15 5L5 15" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button>';
        document.body.appendChild(ov);
        var bigBox = ov.firstChild, closeBtn = ov.lastChild, home = null, homeNext = null, homeBoxV = null, still = null, tClose = 0;
        closeBtn.setAttribute('aria-label', btn.getAttribute('data-close') || '');
        // 02/11/2026 soir (user : « quand on ouvre en grand et referme, ça clignote ») : 2 causes.
        // 1) repaint() cachait la scène pendant une image (astuce du bandeau téléphone) → plus utilisé ici.
        // 2) pendant les fondus, la place de l'aperçu dans la page était VIDE (il était déjà parti dans la
        //    visionneuse, ou revenait alors que la visionneuse s'effaçait encore) → une copie figée de la
        //    scène reste à sa place tant que la visionneuse est ouverte, et l'aperçu ne revient qu'à la fin du fondu.
        function swap() {
          world.classList.add('is-cut');
          layout();
          requestAnimationFrame(function() { requestAnimationFrame(function() { world.classList.remove('is-cut'); }); });
        }
        function putBack() {
          clearTimeout(tClose); tClose = 0;
          if (live.parentNode !== bigBox) return;
          if (ro) ro.unobserve(bigBox);
          home.insertBefore(live, still && still.parentNode === home ? still : (homeNext && homeNext.parentNode === home ? homeNext : null));
          box = homeBoxV;
          swap();
          if (still && still.parentNode) still.parentNode.removeChild(still);
          still = null;
        }
        function open() {
          if (live.__big || live.closest('.ml-live-dock')) return;
          if (tClose) putBack();   // rouvert pendant le fondu de fermeture
          live.__big = true;
          home = live.parentNode; homeNext = live.nextSibling; homeBoxV = box;
          // copie figée à la place de l'aperçu (sans les repères data-ml-* : le reste de la page ne doit pas la prendre pour lui)
          still = live.cloneNode(true);
          [still].concat(Array.prototype.slice.call(still.querySelectorAll('*'))).forEach(function(e) {
            Array.prototype.slice.call(e.attributes).forEach(function(a) { if (/^data-ml-/.test(a.name)) e.removeAttribute(a.name); });
          });
          var stillBtn = still.querySelector('.ml-live__big'); if (stillBtn) stillBtn.parentNode.removeChild(stillBtn);
          still.setAttribute('aria-hidden', 'true');
          still.removeAttribute('role');
          home.insertBefore(still, live);
          // même proportions que dans la page (comme la visionneuse des autres images)
          if (box.clientWidth && box.clientHeight) ov.style.setProperty('--big-ar', (box.clientWidth / box.clientHeight).toFixed(4));
          if (artImg) artImg.sizes = '100vw';   // l'œuvre en plus haute définition
          bigBox.appendChild(live);
          box = bigBox;
          if (ro) ro.observe(bigBox);
          ov.setAttribute('aria-hidden', 'false');
          document.body.classList.add('ml-live-big-open');
          swap();
          void ov.offsetWidth;
          ov.classList.add('is-open');
          try { closeBtn.focus({ preventScroll: true }); } catch (e) {}
        }
        function close() {
          if (!live.__big) return;
          live.__big = false;
          ov.classList.remove('is-open');
          ov.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('ml-live-big-open');
          // l'aperçu reste dans la visionneuse pendant qu'elle s'efface (220 ms), puis reprend sa place
          tClose = setTimeout(putBack, reduce ? 0 : 240);
        }
        btn.addEventListener('click', function(e) { e.stopPropagation(); open(); });
        live.addEventListener('click', function(e) {
          if (live.__big) { close(); return; }
          if (!e.target.closest('button, a')) open();
        });
        ov.addEventListener('click', function(e) { if (e.target === ov || e.target === bigBox || e.target.closest('.ml-live-big__close')) close(); });
        document.addEventListener('keydown', function(e) { if (e.key === 'Escape') close(); });
      })();

      // AFFICHES, TÉLÉPHONE (06/10/2026, demande user, comme Juniqe) : quand la
      // grande image est sortie de l'écran et qu'on règle format / cadre, l'aperçu
      // en direct reste visible dans un bandeau épinglé sous l'en-tête. C'est le
      // MÊME élément, déplacé dans le bandeau puis remis à sa place — un seul
      // moteur, aucune copie à tenir à jour.
      if (isPoster && 'IntersectionObserver' in window) (function dockOnPhone() {
        var variantsEl = section.querySelector('.ml-product__variants');
        var homeBox = box;
        if (!variantsEl || !homeBox) return;
        var mq = window.matchMedia('(max-width: 989px)');
        // Bandeau = petit carrousel : 1re case l'aperçu en direct, puis les
        // images fixes de la galerie (on glisse au doigt, points en bas).
        var dock = document.createElement('div');
        dock.className = 'ml-live-dock';
        dock.innerHTML = '<div class="ml-live-dock__track"><div class="ml-live-dock__slide ml-live-dock__slide--live"></div></div><div class="ml-live-dock__dots" aria-hidden="true"></div>';
        document.body.appendChild(dock);
        var track = dock.firstChild, liveSlide = track.firstChild, dots = dock.lastChild, built = false;
        if (ro) ro.observe(liveSlide);
        // 21/10/2026 (réglage dock_mini) : petite vignette en bas à droite au lieu du
        // bandeau du haut — aperçu en direct seul, toucher = remonter à la grande image.
        // Au-dessus de la barre d'achat collée quand elle est affichée.
        var mini = section.hasAttribute('data-ml-dock-mini');
        if (mini) {
          dock.classList.add('ml-live-dock--mini');
          dock.setAttribute('role', 'button');
          dock.setAttribute('aria-label', mlT('revoir_photos', 'Revoir les photos'));
          dock.addEventListener('click', function() { homeBox.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
          var stickyEl = section.querySelector('[data-ml-sticky]');
          if (stickyEl) {
            var placeDock = function() {
              if (stickyEl.classList.contains('is-visible')) dock.style.setProperty('--dock-bas', stickyEl.offsetHeight + 'px');
              else dock.style.removeProperty('--dock-bas');
            };
            new MutationObserver(placeDock).observe(stickyEl, { attributes: true, attributeFilter: ['class'] });
            placeDock();
          }
        }
        function buildSlides() {
          if (built) return;
          built = true;
          section.querySelectorAll('.ml-product__gallery-inner > .ml-product__media:not(.ml-live) img').forEach(function(img) {
            var sl = document.createElement('div');
            sl.className = 'ml-live-dock__slide';
            var c = img.cloneNode();
            c.removeAttribute('loading');
            c.removeAttribute('class');
            c.alt = '';
            sl.appendChild(c);
            track.appendChild(sl);
          });
          var n = track.children.length;
          for (var i = 0; i < n; i++) dots.appendChild(document.createElement('i'));
          if (n < 2) dots.style.display = 'none';
          markDot();
        }
        function markDot() {
          var first = track.firstChild, step = first ? first.offsetWidth + 8 : 1;
          var max = track.scrollWidth - track.clientWidth;
          var i = track.scrollLeft >= max - 2 && max > 0 ? track.children.length - 1 : Math.round(track.scrollLeft / step);
          Array.prototype.forEach.call(dots.children, function(d, k) { d.classList.toggle('is-on', k === i); });
        }
        track.addEventListener('scroll', function() { requestAnimationFrame(markDot); }, { passive: true });
        // changer de format / cadre : retour sur l'aperçu en direct
        section.addEventListener('change', function() {
          if (docked && track.scrollLeft > 0) track.scrollTo({ left: 0, behavior: 'smooth' });
        });
        var galleryOut = false, optionsIn = false, docked = false;
        function update() {
          if (live.__big) return;
          var want = mq.matches && galleryOut && optionsIn;
          if (want === docked) return;
          docked = want;
          if (want) {
            if (!mini) buildSlides();
            liveSlide.appendChild(live);
            track.scrollLeft = 0;
            box = liveSlide;
            dock.classList.add('is-on');
          } else {
            dock.classList.remove('is-on');
            homeBox.insertBefore(live, homeBox.firstChild);
            box = homeBox;
          }
          markDot();
          world.classList.add('is-cut');
          layout();
          repaint();
          requestAnimationFrame(function() { requestAnimationFrame(function() { world.classList.remove('is-cut'); }); });
        }
        // la galerie compte comme « sortie » quand moins de 40 % reste visible
        // sous l'en-tête (l'affiche, au milieu de la photo, a déjà disparu) ;
        // elle revient au-delà de 50 % — l'écart évite le clignotement
        new IntersectionObserver(function(es) {
          var r = es[0].intersectionRatio;
          if (r < 0.4) galleryOut = true; else if (r > 0.5) galleryOut = false;
          update();
        }, { rootMargin: '-70px 0px 0px 0px', threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8, 1] }).observe(homeBox);
        new IntersectionObserver(function(es) { optionsIn = es[0].isIntersecting; update(); }).observe(variantsEl);
        if (mq.addEventListener) mq.addEventListener('change', update);
      })();
      if (artImg && !artImg.complete) artImg.addEventListener('load', layout);
      // retour à l'écran après un défilement : Safari (iPhone) laisse parfois la scène blanche
      if ('IntersectionObserver' in window) (function() {
        var away = false;
        new IntersectionObserver(function(es) {
          if (es[0].isIntersecting) { if (away) { layout(); repaint(); } away = false; } else away = true;
        }).observe(live);
      })();
      world.classList.add('is-cut');
      animateTo(target());
      requestAnimationFrame(function() { requestAnimationFrame(function() { world.classList.remove('is-cut'); }); });
    })();
    // ATC — intercept the submit (and the button click as a belt-and-suspenders) to do an
    // AJAX add so the product section never re-renders (preserves the variant selection).
    var atcForm = atcBtn ? atcBtn.closest('form') : null;
    if (atcBtn && !atcBtn.dataset.mlAtcBound) {
      atcBtn.dataset.mlAtcBound = '1';
      atcBtn.addEventListener('click', function(e) {
        if (atcBtn.disabled) return;
        // Stop the native submit chain dead. Also stop any other click listeners
        // (e.g. theme-level redirect-to-cart handlers) before they fire.
        e.preventDefault();
        e.stopImmediatePropagation();
        if (atcForm) doAjaxAdd();
      }, true);
    }
    if (atcForm && !atcForm.dataset.mlAtcBound) {
      atcForm.dataset.mlAtcBound = '1';
      atcForm.addEventListener('submit', function(e) {
        if (atcBtn && atcBtn.disabled) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        doAjaxAdd();
      }, true);
    }

    // Change le libellé en fondu doux pour éviter le "saut" du texte.
    function fadeAtcText(txt) {
      if (!atcText) return;
      atcText.style.opacity = '0';
      setTimeout(function() {
        atcText.textContent = txt;
        atcText.style.opacity = '1';
      }, 140);
    }

    function doAjaxAdd() {
      if (!atcForm) return;
      if (atcBtn && atcBtn.disabled) return;
      var originalText = atcText ? atcText.textContent : '';
      // On grise simplement le bouton pendant l'envoi (pas de texte intermédiaire
      // "Ajout en cours…" qui faisait gigoter le libellé).
      atcBtn.disabled = true;

      var formData = new FormData(atcForm);
      // 20/10/2026 (user : « bouton panier vachement lent ») : UN seul aller-retour au lieu de trois.
      // On demande à l'ajout de renvoyer directement le contenu du tiroir panier (comme le bouton
      // d'origine de Horizon) : plus de /cart.js ni de 2e chargement du tiroir après coup.
      var cartSectionIds = [];
      document.querySelectorAll('cart-items-component').forEach(function(el) { if (el.dataset.sectionId) cartSectionIds.push(el.dataset.sectionId); });
      if (cartSectionIds.length) { formData.append('sections', cartSectionIds.join(',')); formData.append('sections_url', window.location.pathname); }
      var qtyAdded = Number(formData.get('quantity')) || 1;
      var cartIcon = document.querySelector('cart-icon');
      var countBefore = cartIcon && typeof cartIcon.currentCartCount === 'number' ? cartIcon.currentCartCount : 0;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
      .then(function(res) {
        if (!res.ok) return res.json().then(function(err) { throw err; });
        return res.json();
      })
      .then(function(itemData) {
        var sections = itemData.sections || null;
        // Notify Horizon (cart icon, cart drawer, etc.) — « product-form-component » : la pastille ajoute la quantité
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: { item_count: countBefore + qtyAdded },
            sourceId: atcBtn.id || 'ml-atc',
            data: { itemCount: qtyAdded, variantId: itemData.variant_id, productId: String(itemData.product_id || ''), source: 'product-form-component', sections: sections }
          }
        }));
        // Try to open the cart drawer if present
        var drawer = document.querySelector('cart-drawer-component, cart-drawer, [is="cart-drawer"]');
        if (drawer) {
          if (typeof drawer.open === 'function') drawer.open();
          else if (typeof drawer.showModal === 'function') drawer.showModal();
          else drawer.setAttribute('open', '');
        }
        // Feedback on the button
        fadeAtcText(mlT('ajoute', 'Ajouté ✓'));
        setTimeout(function() {
          atcBtn.disabled = false;
          fadeAtcText(originalText);
        }, 1400);
      })
      .catch(function(err) {
        console.error('ATC error', err);
        atcBtn.disabled = false;
        fadeAtcText((err && err.description) || mlT('erreur', 'Erreur — réessayer'));
        setTimeout(function() {
          fadeAtcText(originalText);
        }, 3000);
      });
    }

    // Frame selector — update selection state, sync hidden line item property
    var frameWrap = section.querySelector('.ml-frame-selector');
    if (frameWrap) {
      var frameRadios = frameWrap.querySelectorAll('.ml-frame-swatch__input');
      var frameCurrent = frameWrap.querySelector('[data-ml-frame-current]');
      var frameProp = section.querySelector('[data-ml-frame-prop]');
      frameRadios.forEach(function(radio) {
        radio.addEventListener('change', function() {
          frameWrap.querySelectorAll('.ml-frame-swatch').forEach(function(s) { s.classList.remove('is-selected'); });
          radio.closest('.ml-frame-swatch').classList.add('is-selected');
          if (frameCurrent) frameCurrent.textContent = radio.value;
          if (frameProp) frameProp.value = radio.value;
        });
      });
    }

    // Comparatif : la photo macro s'ouvre en plein écran
    var zoomBtn = section.querySelector('[data-ml-zoom]');
    var zoomOverlay = section.querySelector('[data-ml-zoom-overlay]');
    if (zoomBtn && zoomOverlay) {
      var zoomClose = zoomOverlay.querySelector('[data-ml-zoom-close]');
      var openZoom = function() {
        zoomOverlay.hidden = false;
        document.body.classList.add('ml-quality-zoom-open');
      };
      var closeZoom = function() {
        zoomOverlay.hidden = true;
        document.body.classList.remove('ml-quality-zoom-open');
      };
      zoomBtn.addEventListener('click', openZoom);
      if (zoomClose) zoomClose.addEventListener('click', closeZoom);
      zoomOverlay.addEventListener('click', function(e) {
        if (e.target === zoomOverlay || e.target.closest('[data-ml-zoom-close]')) closeZoom();
      });
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && !zoomOverlay.hidden) closeZoom();
      });
    }

    // Galerie : zoom au tap/clic sur l'image principale
    var gZoom = section.querySelector('[data-ml-gallery-zoom]');
    if (gZoom) {
      // Sortir l'overlay au niveau du <body> : évite que les cartes taille/cadre
      // (dans une colonne sticky) ne repassent devant l'image agrandie.
      if (gZoom.parentNode !== document.body) document.body.appendChild(gZoom);
      var gZoomImg = gZoom.querySelector('[data-ml-gallery-zoom-img]');
      var gZoomClose = gZoom.querySelector('[data-ml-gallery-zoom-close]');
      var gZoomPrev = gZoom.querySelector('[data-ml-gallery-zoom-prev]');
      var gZoomNext = gZoom.querySelector('[data-ml-gallery-zoom-next]');
      var gZoomCounter = gZoom.querySelector('[data-ml-gallery-zoom-counter]');
      // Liste des images navigables (les vidéos ne sont pas des <img>, donc exclues).
      var galleryImgs = Array.prototype.slice.call(section.querySelectorAll('img.ml-product__media-img'));
      var currentZoomIndex = 0;

      // Charge une image dans la visionneuse : affichage instantané (image en cache)
      // puis montée en haute résolution en arrière-plan.
      var loadZoomImage = function(srcImg) {
        var displayed = srcImg.currentSrc || srcImg.src;
        gZoomImg.alt = srcImg.alt || '';
        gZoomImg.src = displayed;
        var hi = displayed ? displayed.replace(/([?&]width=)\d+/, '$11600') : '';
        if (hi && hi !== displayed) {
          var pre = new Image();
          pre.onload = function() {
            // On ne remplace que si la même image est toujours affichée.
            if ((gZoomImg.currentSrc || gZoomImg.src) === displayed) gZoomImg.src = hi;
          };
          pre.src = hi;
        }
      };

      // Loupe (17/10/2026) : sur les images d'au moins 3000 px (fonds blancs HD des affiches).
      // Ordinateur : un cercle grossissant suit la souris (pas de clic). Téléphone : toucher = agrandir
      // là où on a visé, glisser = promener la vue, second toucher = image entière (object-fit: none).
      // Une seule taille HD (HD_W) : Shopify la garde en cache (la 1re demande d'une taille prend 1-2 s),
      // préchargée dès que la photo s'ouvre ; en attendant, le cercle montre l'image déjà affichée.
      var HD_W = 3200;
      var loupe = { on: false, x: 50, y: 50, w: 0, h: 0, req: 0 };
      var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      var hdUrl = function(base) {
        return /[?&]width=\d+/.test(base) ? base.replace(/([?&]width=)\d+/, '$1' + HD_W) : base + (base.indexOf('?') < 0 ? '?' : '&') + 'width=' + HD_W;
      };
      var hdReady = {};
      var hdPreload = function(base) {
        var url = hdUrl(base);
        if (hdReady[url]) return;
        hdReady[url] = 'loading';
        var im = new Image();
        im.onload = function() { hdReady[url] = { w: im.naturalWidth, h: im.naturalHeight }; if (lens.on) lensMove(lens.cx, lens.cy); };
        im.onerror = function() { delete hdReady[url]; };
        im.src = url;
      };
      // cercle (ordinateur)
      var lens = { el: document.createElement('div'), on: false, cx: 0, cy: 0 };
      lens.el.className = 'ml-zoom-lens';
      lens.el.setAttribute('aria-hidden', 'true');
      gZoom.appendChild(lens.el);
      var lensMove = function(cx, cy) {
        lens.cx = cx; lens.cy = cy;
        var r = gZoomImg.getBoundingClientRect();
        var nw = gZoomImg.naturalWidth, nh = gZoomImg.naturalHeight;
        if (!r.width || !nw) return;
        // l'image est en object-fit: cover dans la visionneuse : retrouver où elle est vraiment dessinée
        var sc = Math.max(r.width / nw, r.height / nh), dw = nw * sc, dh = nh * sc;
        var ox = r.left + (r.width - dw) / 2, oy = r.top + (r.height - dh) / 2;
        var u = (cx - ox) / dw, v = (cy - oy) / dh;
        var inside = cx >= r.left && cx <= r.right && cy >= r.top && cy <= r.bottom;
        lens.el.classList.toggle('is-on', inside);
        if (!inside) return;
        var base = gZoomImg.dataset.base || gZoomImg.currentSrc || gZoomImg.src, url = hdUrl(base);
        var src = hdReady[url] && hdReady[url] !== 'loading' ? url : (gZoomImg.currentSrc || gZoomImg.src);
        var k = 3.2, R = lens.el.offsetWidth / 2, bw = dw * k, bh = dh * k;
        lens.el.style.left = cx + 'px';
        lens.el.style.top = cy + 'px';
        if (lens.el.dataset.src !== src) { lens.el.style.backgroundImage = 'url("' + src + '")'; lens.el.dataset.src = src; }
        lens.el.style.backgroundSize = bw + 'px ' + bh + 'px';
        lens.el.style.backgroundPosition = (R - u * bw) + 'px ' + (R - v * bh) + 'px';
      };
      var lensOff = function() { lens.on = false; lens.el.classList.remove('is-on'); };
      var loupePos = function() { gZoomImg.style.objectPosition = loupe.x + '% ' + loupe.y + '%'; };
      var loupeOff = function() {
        loupe.on = false; loupe.req++;
        gZoomImg.classList.remove('is-loupe');
        gZoomImg.removeAttribute('srcset');
        gZoomImg.style.objectPosition = '';
      };
      var loupeIn = function(cx, cy) {
        var r = gZoomImg.getBoundingClientRect();
        if (!r.width) return;
        loupe.x = Math.max(0, Math.min(100, (cx - r.left) / r.width * 100));
        loupe.y = Math.max(0, Math.min(100, (cy - r.top) / r.height * 100));
        var dpr = Math.min(window.devicePixelRatio || 1, 3);
        // grossissement : jusqu'au pixel près de l'image HD, entre 2,5 et 5 fois la vue
        loupe.w = Math.max(r.width * 2.5, Math.min(HD_W / dpr, r.width * 5));
        var url = hdUrl(gZoomImg.dataset.base || gZoomImg.currentSrc || gZoomImg.src);
        var ticket = ++loupe.req;
        loupe.on = true;
        gZoom.classList.add('is-loading');
        var pre = new Image();
        pre.onload = function() {
          if (ticket !== loupe.req) return;
          gZoom.classList.remove('is-loading');
          // densité choisie pour que l'image fasse loupe.w pixels CSS de large
          gZoomImg.srcset = url + ' ' + (pre.naturalWidth / loupe.w).toFixed(4) + 'x';
          gZoomImg.classList.add('is-loupe');
          loupe.h = loupe.w * pre.naturalHeight / pre.naturalWidth;
          loupePos();
        };
        pre.onerror = function() { if (ticket === loupe.req) { gZoom.classList.remove('is-loading'); loupeOff(); } };
        pre.src = url;
      };
      // souris : le cercle suit le pointeur
      gZoom.addEventListener('mousemove', function(e) {
        if (!finePointer || !gZoom.classList.contains('can-loupe')) { if (lens.on) lensOff(); return; }
        lens.on = true;
        lensMove(e.clientX, e.clientY);
      });
      gZoomImg.addEventListener('mouseleave', lensOff);
      // toucher bref sans glisser = ouvrir / fermer la loupe (certains téléphones n'en font pas un « click »)
      var tap = null, lastTap = 0;
      gZoomImg.addEventListener('touchstart', function(e) {
        tap = e.touches.length === 1 ? { x: e.touches[0].clientX, y: e.touches[0].clientY, t: Date.now() } : null;
      }, { passive: true });
      gZoomImg.addEventListener('touchend', function(e) {
        if (!tap || !gZoom.classList.contains('can-loupe')) { tap = null; return; }
        var t = e.changedTouches[0], p = tap; tap = null;
        if (Math.abs(t.clientX - p.x) + Math.abs(t.clientY - p.y) > 12 || Date.now() - p.t > 450) return;
        e.preventDefault();
        lastTap = Date.now();
        if (loupe.on) loupeOff(); else loupeIn(t.clientX, t.clientY);
      }, { passive: false });
      // doigt : on fait glisser l'image agrandie
      var lt = null;
      gZoomImg.addEventListener('touchstart', function(e) {
        if (!loupe.on || e.touches.length !== 1) { lt = null; return; }
        lt = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }, { passive: true });
      gZoomImg.addEventListener('touchmove', function(e) {
        if (!loupe.on || !lt || e.touches.length !== 1) return;
        e.preventDefault();
        var r = gZoomImg.getBoundingClientRect();
        var t = e.touches[0], dx = t.clientX - lt.x, dy = t.clientY - lt.y;
        lt = { x: t.clientX, y: t.clientY };
        var spanX = Math.max(1, loupe.w - r.width), spanY = Math.max(1, (loupe.h || loupe.w) - r.height);
        loupe.x = Math.max(0, Math.min(100, loupe.x - dx / spanX * 100));
        loupe.y = Math.max(0, Math.min(100, loupe.y - dy / spanY * 100));
        loupePos();
      }, { passive: false });

      // Affiche l'image à l'index donné (avec bouclage début/fin).
      var showZoomAt = function(index) {
        if (!galleryImgs.length) return;
        if (index < 0) index = galleryImgs.length - 1;
        if (index >= galleryImgs.length) index = 0;
        currentZoomIndex = index;
        loupeOff();
        loadZoomImage(galleryImgs[index]);
        gZoomImg.dataset.base = galleryImgs[index].currentSrc || galleryImgs[index].src;
        var holder = galleryImgs[index].closest('.ml-product__media');
        var hd = !!(holder && +holder.getAttribute('data-ml-w') >= 3000);
        gZoom.classList.toggle('can-loupe', hd);
        gZoom.classList.toggle('has-lens', hd && finePointer);
        lensOff();
        if (hd) hdPreload(gZoomImg.dataset.base);
        if (gZoomCounter) gZoomCounter.textContent = (index + 1) + ' / ' + galleryImgs.length +
          (hd ? (finePointer ? ' · ' + mlT('zoom_survol', 'Survolez l\u2019affiche pour zoomer') : ' · ' + mlT('zoom_toucher', 'Touchez pour zoomer')) : '');
      };

      var openGallery = function(srcImg) {
        // On reprend le MÊME cadrage (crop) que la vignette de la galerie : on mesure
        // le ratio réellement affiché et on l'applique à la visionneuse (object-fit: cover).
        // Le cadre galerie étant identique pour toutes les images, ce ratio vaut aussi
        // pour la navigation suivante/précédente.
        var rect = srcImg.getBoundingClientRect();
        var ratio = (rect && rect.height) ? (rect.width / rect.height) : (srcImg.naturalWidth / srcImg.naturalHeight);
        if (ratio && isFinite(ratio)) gZoomImg.style.setProperty('--zoom-aspect', ratio);
        var startIndex = galleryImgs.indexOf(srcImg);
        showZoomAt(startIndex < 0 ? 0 : startIndex);
        gZoom.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ml-gallery-zoom-open');
        // Forcer un reflow puis ajouter la classe → transition d'ouverture fluide.
        void gZoom.offsetWidth;
        gZoom.classList.add('is-open');
      };

      if (gZoomPrev) gZoomPrev.addEventListener('click', function(e) {
        e.stopPropagation();
        showZoomAt(currentZoomIndex - 1);
      });
      if (gZoomNext) gZoomNext.addEventListener('click', function(e) {
        e.stopPropagation();
        showZoomAt(currentZoomIndex + 1);
      });

      // Navigation au swipe horizontal (mobile/tactile).
      var touchStartX = null;
      gZoom.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });
      gZoom.addEventListener('touchend', function(e) {
        if (touchStartX === null) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (loupe.on) return;   // loupe ouverte : le doigt promène la vue, pas d'image suivante
        // Mode « guide des tailles » (is-single) : une seule image, donc pas de
        // navigation. Sans ce garde-fou, un simple glissement du doigt remplaçait
        // le guide par le mockup produit — la visionneuse restant ouverte.
        if (gZoom.classList.contains('is-single')) return;
        if (Math.abs(dx) > 40) showZoomAt(currentZoomIndex + (dx < 0 ? 1 : -1));
      }, { passive: true });
      var closeGallery = function() {
        gZoom.classList.remove('is-open');
        gZoom.classList.remove('is-single');
        gZoom.classList.remove('can-loupe');
        gZoom.classList.remove('has-lens');
        loupeOff();
        lensOff();
        gZoom.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ml-gallery-zoom-open');
        window.setTimeout(function() {
          if (!gZoom.classList.contains('is-open')) gZoomImg.removeAttribute('src');
        }, 240);
      };
      // Guide des tailles : MÊME visionneuse que la galerie, mais sur une seule
      // image — pas de flèches, pas de compteur, et l'image entière visible
      // (le mode galerie recadre en cover, ce qui rognerait le schéma).
      // Rien ne s'ouvre dans un onglet ni dans une fenêtre du navigateur.
      var openSingle = function(srcImg) {
        if (!srcImg) return;
        gZoom.classList.add('is-single');
        gZoomImg.alt = srcImg.alt || '';
        gZoomImg.src = srcImg.currentSrc || srcImg.src;
        if (gZoomCounter) gZoomCounter.textContent = '';
        gZoom.setAttribute('aria-hidden', 'false');
        document.body.classList.add('ml-gallery-zoom-open');
        void gZoom.offsetWidth;
        gZoom.classList.add('is-open');
      };
      // Marche dans les deux cas : bande affichée, ou simple image cachée.
      var guideImg = section.querySelector('[data-ml-size-guide-img]');
      if (guideImg) {
        var guideBtn = section.querySelector('[data-ml-size-guide-open]');
        if (guideBtn) guideBtn.addEventListener('click', function() { openSingle(guideImg); });
        // Le lien « Guide des tailles » ouvre l'image directement au lieu de
        // faire défiler la page. Le href reste une ancre : si le JS ne tourne
        // pas, le lien descend quand même jusqu'au guide.
        section.querySelectorAll('.ml-size-guide-link').forEach(function(link) {
          link.addEventListener('click', function(e) {
            e.preventDefault();
            openSingle(guideImg);
          });
        });
      }

      section.querySelectorAll('img.ml-product__media-img').forEach(function(img) {
        img.addEventListener('click', function() { openGallery(img); });
      });
      gZoom.addEventListener('click', function(e) {
        if (e.target.closest('[data-ml-gallery-zoom-close]')) { closeGallery(); return; }
        // Guide des tailles : on veut pouvoir regarder le schéma sans que le
        // moindre appui dessus referme tout. On ferme sur le fond noir ou la croix.
        if (e.target === gZoomImg && gZoom.classList.contains('is-single')) return;
        if (e.target === gZoomImg && gZoom.classList.contains('can-loupe')) {
          if (finePointer) return;                  // ordinateur : le cercle suffit, un clic ne ferme pas
          if (Date.now() - lastTap < 700) return;   // déjà traité au toucher
          if (loupe.on) loupeOff(); else loupeIn(e.clientX, e.clientY);
          return;
        }
        if (e.target === gZoom || e.target === gZoomImg) closeGallery();
      });
      document.addEventListener('keydown', function(e) {
        if (!gZoom.classList.contains('is-open')) return;
        if (e.key === 'Escape') { closeGallery(); return; }
        if (gZoom.classList.contains('is-single')) return;
        if (e.key === 'ArrowLeft') showZoomAt(currentZoomIndex - 1);
        else if (e.key === 'ArrowRight') showZoomAt(currentZoomIndex + 1);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('.ml-product[data-section-id]').forEach(function(el) {
      initProductPage(el.dataset.sectionId);
    });
  }

  // Run immediately if DOM is already parsed. Without this, when the script runs after
  // DOMContentLoaded has already fired (typical under Horizon's module loading), the listener
  // never triggers → init never runs → first click on size cards / ATC is ignored.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.detail && e.detail.sectionId) initProductPage(e.detail.sectionId);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ml-same-collection"] && !Shopify.designMode) return;
  try {
    
  // Flèches du carrousel « même collection » : une page de cartes à la fois.
  document.addEventListener('click', function(e) {
    var b = e.target.closest && e.target.closest('.ml-sc__arrow');
    if (!b) return;
    var grid = b.closest('.ml-sc').querySelector('.ml-sc__grid');
    if (grid) grid.scrollBy({ left: (+b.getAttribute('data-sc-dir') || 1) * grid.clientWidth * 0.8, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
